"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.setRemoteSyncEnabled = exports.isRemoteControllingEnabled = exports.isRemoteControllingEnabledWhenOnline = exports.isKesiAuthor = exports.isKesiExpert = exports.isKesiMaster = exports.CORDOVA_SERVER_URLS = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _config = _interopRequireDefault(require("../../targets/cord_sanofi/config.js"));

var _BuildConstants = require("../utils/BuildConstants");

var _jszip = _interopRequireDefault(require("jszip"));

var _axios = _interopRequireDefault(require("axios"));

var _ContentParser = _interopRequireDefault(require("./entities/ContentParser"));

var _CordovaFileHelper = _interopRequireWildcard(require("../helpers/CordovaFileHelper"));

var _FeatureManager = _interopRequireDefault(require("../utils/features/FeatureManager"));

var _FileSystemWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileSystemWrapper"));

var _FileTransferWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/FileTransferWrapper"));

var _ArrayHelper = require("../helpers/ArrayHelper");

var _KESI2StoreHelper = _interopRequireDefault(require("./KESI2StoreHelper"));

var _Lecture = _interopRequireDefault(require("./entities/Lecture"));

var _Nugget = _interopRequireDefault(require("./entities/Nugget"));

var _RegisterInstance = _interopRequireDefault(require("./Services/RegisterInstance"));

var _Spoc = _interopRequireDefault(require("./entities/Spoc"));

var _SpocRoot = _interopRequireDefault(require("./entities/SpocRoot"));

var _ZipWrapper = _interopRequireDefault(require("../cordovaPluginWrappers/ZipWrapper"));

var _DataStore = _interopRequireWildcard(require("./Stores/DataStore2"));

var _ChunkedPromises = require("../utils/ChunkedPromises");

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _index = require("./Services/RemoteControlService/index");

var _HttpRequest = require("../utils/HttpRequest");

var _TimeoutHelper = require("../helpers/TimeoutHelper");

var _KesiFileConsistencyHelper = _interopRequireDefault(require("../helpers/KesiFileConsistencyHelper"));

var _MuiAlertHelper = require("../helpers/MuiAlertHelper");

var _strings = require("../../config/strings");

var _VoteNugget = _interopRequireDefault(require("./entities/nuggets/VoteNugget"));

var _StringHelper = _interopRequireDefault(require("../helpers/StringHelper"));

var _ChatNugget = _interopRequireDefault(require("./entities/nuggets/ChatNugget"));

var _Course = _interopRequireDefault(require("./entities/Course"));

var _PreconditionChecker = require("../utils/PreconditionChecker");

var _LiveTickerNugget = _interopRequireDefault(require("./entities/nuggets/LiveTickerNugget"));

var _UserAgent = require("../utils/UserAgent");

var _EventDate = _interopRequireDefault(require("./entities/EventDate"));

var _EventSeries = _interopRequireDefault(require("./entities/EventSeries"));

var _SnackbarHelper = require("../helpers/SnackbarHelper");

var _Constants = require("../common/constants/Constants");

var _PreconditionActionExecutioner = require("../utils/PreconditionActionExecutioner");

var _NavigationManagerCordova = _interopRequireDefault(require("../common/NavigationManagerCordova"));

var CORDOVA_SERVER_URLS = {
  ALL_CONTENT: _config["default"] ? _config["default"].allContentRetrieveUrl : null,
  VISIBILITIES: 'visibility',
  FINISHED_CHATS: 'finishedChats'
};
exports.CORDOVA_SERVER_URLS = CORDOVA_SERVER_URLS;
var MIME_TYPES = {
  COURSE: 'application/json-course',
  SPOC: 'application/json-spoc',
  LECTURE: 'application/json-lecture',
  NEWS_BLOCK: 'application/json-newsblock',
  NUGGET: 'application/json-nugget'
};
var EVENT_TYPE = 'event';
var EVENT_DATE = 'eventDate';
var MAZARS_CERT_TYPE = 'mazarscert';
var remoteSyncEnabled = true;

var isKesiMaster = function isKesiMaster() {
  return _config["default"].isKesiMaster || Boolean(_FeatureManager["default"].getFeature(_config["default"].kesiMasterFeatureName));
};

exports.isKesiMaster = isKesiMaster;

var isKesiExpert = function isKesiExpert() {
  return Boolean(_FeatureManager["default"].getFeature(_config["default"].kesiExpertFeatureName));
};

exports.isKesiExpert = isKesiExpert;

var isKesiAuthor = function isKesiAuthor() {
  return Boolean(_FeatureManager["default"].getFeature(_config["default"].kesiAuthorFeatureName));
};

exports.isKesiAuthor = isKesiAuthor;

var isRemoteControllingEnabledWhenOnline = function isRemoteControllingEnabledWhenOnline() {
  return remoteSyncEnabled && isKesiMaster();
};

exports.isRemoteControllingEnabledWhenOnline = isRemoteControllingEnabledWhenOnline;

var isRemoteControllingEnabled = function isRemoteControllingEnabled() {
  return remoteSyncEnabled && isKesiMaster() && window.ablyConnectivity && window.ablyConnectivity.state === 'connected';
};

exports.isRemoteControllingEnabled = isRemoteControllingEnabled;

var setRemoteSyncEnabled = function setRemoteSyncEnabled(enabled) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var nextPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var scrollTop = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (enabled) {
    (0, _index.pushNavigateMessage)(id, nextPath, scrollTop);
  }

  remoteSyncEnabled = enabled;
};

exports.setRemoteSyncEnabled = setRemoteSyncEnabled;
var DELETE_FILES_TIMEOUT = 10000; // 10 sec

var KESI2Helper = /*#__PURE__*/function () {
  function KESI2Helper() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, KESI2Helper);
    (0, _defineProperty2["default"])(this, "getEventDateByUuid", function (uuid) {
      var contentToReturn = null;
      (0, _keys["default"])(_this.data.contents).find(function (contentId) {
        var content = _this.data.contents[contentId];

        if (content instanceof _EventDate["default"]) {
          if (content.uuid === uuid) {
            contentToReturn = content;
            return true;
          }
        }

        return false;
      });
      return contentToReturn;
    });
    (0, _defineProperty2["default"])(this, "getAllLectureDataImmediately", function () {
      var contentToReturn = [];

      if (_this.data && _this.data.contents && _this.data.lectureIds) {
        _this.data.lectureIds.forEach(function (lectureId) {
          contentToReturn.push(_this.data.contents[lectureId]);
        });
      }

      return contentToReturn;
    });
    (0, _defineProperty2["default"])(this, "getAllSpocDataImmediately", function () {
      var contentToReturn = [];

      if (_this.data && _this.data.contents && _this.data.spocIds) {
        _this.data.spocIds.forEach(function (spocId) {
          contentToReturn.push(_this.data.contents[spocId]);
        });
      }

      return contentToReturn;
    });
    (0, _defineProperty2["default"])(this, "getAllCourseDataImmediately", function () {
      var contentToReturn = [];

      if (_this.data && _this.data.contents && _this.data.courseIds) {
        _this.data.courseIds.forEach(function (courseId) {
          contentToReturn.push(_this.data.contents[courseId]);
        });
      }

      return contentToReturn;
    });
    (0, _defineProperty2["default"])(this, "resetCachedProgressCompletely", function () {
      _this.percentages = {};
    });
    (0, _defineProperty2["default"])(this, "resetCachedProgressOfParents", function (contentId) {
      var content = _this.data.contents[contentId];

      if (content.type === _Constants.CONTENT_TYPES.NUGGETS) {
        var lectures = _this.getAllLectureDataImmediately();

        var parent = lectures.find(function (lecture) {
          return lecture.nuggetIds.indexOf(contentId) !== -1;
        });

        if (parent && parent.id) {
          if (_this.percentages[parent.id]) {
            delete _this.percentages[parent.id];
          }

          _this.resetCachedProgressOfParents(parent.id);
        }
      } else if (content.type === _Constants.CONTENT_TYPES.LECTURE) {
        var spocs = _this.getAllSpocDataImmediately();

        var courses = _this.getAllCourseDataImmediately();

        var parentSpoc = spocs.find(function (spoc) {
          return spoc.lectureIds.indexOf(contentId) !== -1;
        });
        var parentCourse = courses.find(function (course) {
          return course.lectureIds.indexOf(contentId) !== -1;
        });

        if (parentSpoc && parentSpoc.id) {
          if (_this.percentages[parentSpoc.id]) {
            delete _this.percentages[parentSpoc.id];
          }

          _this.resetCachedProgressOfParents(parentSpoc.id);
        }

        if (parentCourse && parentCourse.id) {
          if (_this.percentages[parentCourse.id]) {
            delete _this.percentages[parentCourse.id];
          }
        }
      } else if (content.type === _Constants.CONTENT_TYPES.SPOC) {
        var _courses = _this.getAllCourseDataImmediately();

        var _parentCourse = _courses.find(function (course) {
          return course.spocIds.indexOf(contentId) !== -1;
        });

        if (_parentCourse && _parentCourse.id) {
          if (_this.percentages[_parentCourse.id]) {
            delete _this.percentages[_parentCourse.id];
          }
        }
      }

      if (_this.percentages[contentId]) {
        delete _this.percentages[contentId];
      }
    });
    (0, _defineProperty2["default"])(this, "checkIfNotMandatory", function (contentId) {
      if (_this.data && _this.data.contents) {
        var content = _this.data.contents[contentId];
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

        if (failingPrecondition) {
          // if a content should not be shown -> handle it as not mandatory
          return true;
        }

        if (content.type === _Constants.CONTENT_TYPES.COURSE) {
          if (_this.mandatoryCourses.indexOf(contentId) !== -1) return false;
          var lectureIds = content.lectureIds;
          var spocIds = content.spocIds;
          var mandatoryLecture;
          var mandatorySpoc;

          if (lectureIds.length > 0) {
            mandatoryLecture = lectureIds.find(function (lectureId) {
              return _this.checkIfNotMandatory(lectureId) === false;
            });
          }

          if (spocIds.length > 0) {
            mandatorySpoc = spocIds.find(function (spocId) {
              return _this.checkIfNotMandatory(spocId) === false;
            });
          }

          if (mandatoryLecture || mandatorySpoc) {
            _this.mandatoryCourses.push(contentId);

            return false;
          }

          return true;
        } else if (content.type === _Constants.CONTENT_TYPES.SPOC) {
          if (_this.mandatorySpocs.indexOf(contentId) !== -1) return false;
          var _lectureIds = content.lectureIds;

          var _mandatoryLecture = _lectureIds.find(function (lectureId) {
            return _this.checkIfNotMandatory(lectureId) === false;
          });

          if (_mandatoryLecture) {
            _this.mandatorySpocs.push(contentId);

            return false;
          }

          return true;
        } else if (content.type === _Constants.CONTENT_TYPES.LECTURE) {
          if (_this.mandatoryLectures.indexOf(contentId) !== -1) return false;
          var nuggetIds = content.nuggetIds;
          var mandatoryNugget = nuggetIds.find(function (nuggetId) {
            var nuggetContent = _this.data.contents[nuggetId];
            return nuggetContent.notMandatory === false;
          });

          if (mandatoryNugget) {
            _this.mandatoryLectures.push(contentId);

            return false;
          }

          return true;
        }
      }

      return true;
    });
    (0, _defineProperty2["default"])(this, "getPercentageForContent", function (contentId) {
      if (_config["default"].markOpenedLecturesAsCompletelyRead) {
        var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA);

        if (additionalData && additionalData[contentId]) {
          return additionalData[contentId].read ? 100 : 0;
        }

        return 0;
      }

      if (_this.percentages[contentId]) {
        _this.checkTargetSpeficicReadFns(contentId, _this.percentages[contentId] >= 100);

        return _this.percentages[contentId];
      }

      var percentageToReturn = 0;
      var content = _this.data.contents[contentId];

      if (content.type === _Constants.CONTENT_TYPES.COURSE) {
        var coursePercentage = 0;
        var childCount = 0;

        if (content.spocIds && content.spocIds.length > 0) {
          content.spocIds.forEach(function (spocId) {
            var spocContent = _this.data.contents[spocId];

            if (spocContent) {
              var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(spocContent.showPrecondition);

              if (!failingPrecondition) {
                coursePercentage += _this.getPercentageForContent(spocId);
                childCount++;
              }
            }
          });
        }

        if (content.lectureIds && content.lectureIds.length > 0) {
          content.lectureIds.forEach(function (lectureId) {
            var lectureContent = _this.data.contents[lectureId];

            if (lectureContent) {
              var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(lectureContent.showPrecondition);

              if (!failingPrecondition) {
                coursePercentage += _this.getPercentageForContent(lectureId);
                childCount++;
              }
            }
          });
        }

        _this.percentages[contentId] = coursePercentage / childCount > 100 ? 100 : Math.ceil(coursePercentage / childCount);
        percentageToReturn = coursePercentage / childCount > 100 ? 100 : Math.ceil(coursePercentage / childCount);
      } else if (content.type === _Constants.CONTENT_TYPES.SPOC) {
        var spocPercentage = 0;
        var _childCount = 0;

        if (content.lectureIds && content.lectureIds.length > 0) {
          content.lectureIds.forEach(function (lectureId) {
            var lectureContent = _this.data.contents[lectureId];

            if (lectureContent) {
              var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(lectureContent.showPrecondition);

              if (!failingPrecondition) {
                spocPercentage += _this.getPercentageForContent(lectureId);
                _childCount++;
              }
            }
          });
          _this.percentages[contentId] = spocPercentage / _childCount > 100 ? 100 : Math.ceil(spocPercentage / _childCount);
          percentageToReturn = spocPercentage / _childCount > 100 ? 100 : Math.ceil(spocPercentage / _childCount);
        }
      } else if (content.type === _Constants.CONTENT_TYPES.LECTURE) {
        var lecturePercentage = 0;
        var _childCount2 = 0;

        if (content.nuggetIds && content.nuggetIds.length > 0) {
          content.nuggetIds.forEach(function (nuggetId) {
            var nuggetContent = _this.data.contents[nuggetId];

            if (nuggetContent && !nuggetContent.notMandatory) {
              var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(nuggetContent.showPrecondition);

              if (!failingPrecondition) {
                lecturePercentage += _this.getPercentageForContent(nuggetId);
                _childCount2++;
              }
            }
          });
          _this.percentages[contentId] = lecturePercentage / _childCount2 > 100 ? 100 : Math.ceil(lecturePercentage / _childCount2);
          percentageToReturn = lecturePercentage / _childCount2 > 100 ? 100 : Math.ceil(lecturePercentage / _childCount2);
        }
      } else {
        var nuggetPercent = _this.checkIfContentIsMarkedAsReadInStore(content) ? 100 : 0;
        _this.percentages[contentId] = nuggetPercent;
        percentageToReturn = nuggetPercent;
      }

      var read = _this.checkIfContentIsMarkedAsReadInStore(null, contentId);

      if (read && percentageToReturn < 100) {
        _this.setReadForId(contentId, false);
      } else if (!read && percentageToReturn >= 100) {
        _this.setReadForId(contentId, true);
      }

      return percentageToReturn;
    });
    (0, _defineProperty2["default"])(this, "checkIfAllContentDone", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(state) {
        var allDone, courses, spocs, certificatePath;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                allDone = false;

                if (_config["default"].usesCourses) {
                  courses = [];

                  if (_this.data && _this.data.contents && _this.data.courseIds) {
                    _this.data.courseIds.forEach(function (courseId) {
                      courses.push(_this.data.contents[courseId]);
                    });
                  }

                  allDone = courses.every(function (course) {
                    var lecturesDone = _this.checkIfLecturesDone(course.lectureIds);

                    var spocsDone = course.spocIds && course.spocIds.length ? course.spocIds.every(function (spocId) {
                      var spocContent = _this.getContentById(spocId);

                      return _this.checkIfLecturesDone(spocContent.lectureIds);
                    }) : true;
                    return lecturesDone && spocsDone;
                  });
                } else {
                  spocs = [];

                  if (_this.data && _this.data.contents && _this.data.spocIds) {
                    _this.data.spocIds.forEach(function (spocId) {
                      spocs.push(_this.data.contents[spocId]);
                    });
                  }

                  allDone = spocs.every(function (spoc) {
                    return _this.checkIfLecturesDone(spoc.lectureIds);
                  });
                } // this is necessary, if new ffz content is added and the user already has a certificate


                certificatePath = "public.".concat(_config["default"].pdfFeature ? _config["default"].pdfFeature : _config["default"].requiredFeature, ".newCertificateDate");

                if (!(_DataStore["default"].pathExists(certificatePath) && _config["default"].sendCertificate && !allDone)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return _DataStore["default"].removeData(certificatePath);

              case 6:
                return _context.abrupt("return", allDone);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "getContentByKeyword", function (keyword) {
      var keywordId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].keyword === keyword;
      });
      return _this.data.contents[keywordId];
    });
    (0, _defineProperty2["default"])(this, "getGlossary", function () {
      var glossaryId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].subtype === 'glossary';
      });
      return _this.data.contents[glossaryId];
    });
    (0, _defineProperty2["default"])(this, "getRegisterForm", function () {
      var registerFormId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].subtype === 'registerForm';
      });
      console.log('getRegisterFormId', registerFormId);
      return _this.data.contents[registerFormId];
    });
    (0, _defineProperty2["default"])(this, "getSettingsConfig", function () {
      var settingsConfig = _this.data && _this.data.settings && (0, _keys["default"])(_this.data.settings).length > 0 ? _this.data.settings[(0, _keys["default"])(_this.data.settings)[0]] : null;

      if (settingsConfig && settingsConfig.config) {
        return settingsConfig.config;
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "getTutorial", function () {
      var tutorialId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].keyword === _config["default"].hiddenContentSubtype;
      });

      if (tutorialId) {
        var tutorialLectures = _this.data.contents[tutorialId].lectures;
        var tutorialNuggets = _this.data.contents[tutorialId].nuggetIds;

        if (tutorialLectures && tutorialLectures.length > 0) {
          var content = _this.data.contents[tutorialLectures[0].id];
          return content;
        }

        if (tutorialNuggets && tutorialNuggets.length > 0) {
          return _this.data.contents[tutorialId];
        }
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "getQRLogIn", function () {
      var loginId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].keyword === 'qrlogin';
      });

      if (loginId) {
        return _this.data.contents[loginId];
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "getLogIn", function () {
      var loginId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].keyword === 'login';
      });

      if (loginId) {
        var loginLectures = _this.data.contents[loginId].lectures;

        if (loginLectures && loginLectures.length > 0) {
          return _this.data.contents[loginLectures[0].id];
        }
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "getLikertResult", function () {
      var likertResultId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key]["class"] === 'likertresult';
      });

      if (likertResultId) {
        return _this.data.contents[likertResultId];
      }

      return null;
    });
    (0, _defineProperty2["default"])(this, "getMenuContent", function () {
      var menuId = _this.data && _this.data.contents && (0, _keys["default"])(_this.data.contents).find(function (key) {
        return _this.data.contents[key].keyword === 'equeoqd_menu';
      });
      return _this.data.contents[menuId];
    });
    (0, _defineProperty2["default"])(this, "checkIfContentIsMarkedAsReadInStore", function (contentToCheck, id) {
      var read = false;
      var content = contentToCheck;

      if (!content && id) {
        content = _this.getContentById(id);
      }

      var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA);

      if (content.notMandatory) {
        return true;
      }

      if (additionalData && content && content.id) {
        if (_config["default"].translateDrupalIds) {
          var oldId = _config["default"].translateDrupalIdFn(content.id);

          read = additionalData[oldId] && additionalData[oldId].read && additionalData[oldId].read === true;
        } else {
          read = additionalData[content.id] && additionalData[content.id].read && additionalData[content.id].read === true;
        }
      }

      return read;
    });
    (0, _defineProperty2["default"])(this, "checkIfContentVisible", function (id) {
      var content = _this.getContentById(id);

      if (content) {
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

        if (!failingPrecondition) {
          return true;
        }
      }

      return false;
    });
    (0, _defineProperty2["default"])(this, "checkIfContentAccessible", function (id, callback) {
      var content = _this.getContentById(id);

      if (content) {
        var failingOpenPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);

        if (failingOpenPrecondition) {
          var continueOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failingOpenPrecondition);

          if (failingOpenPrecondition) {
            (0, _PreconditionActionExecutioner.preconditionAction)(failingOpenPrecondition, continueOnFail ? function () {} : function () {
              return _NavigationManagerCordova["default"].goHome();
            });
            return !!continueOnFail;
          }
        } else {
          return true;
        }
      }

      return false;
    });
    (0, _defineProperty2["default"])(this, "checkTargetSpeficicReadFns", function (id, read) {
      if (_config["default"].specialReadFns && _config["default"].specialReadFns[id]) {
        var value = _DataStore["default"].getElementByPathImmediately(_config["default"].specialReadFns[id].path);

        if (read && !value) {
          _config["default"].specialReadFns[id].setCallback();
        } else if (!read && !!value) {
          _config["default"].specialReadFns[id].unsetCallback();
        }
      }
    });
    (0, _defineProperty2["default"])(this, "setContentsAsSeen", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(contents) {
        var seenFromStore, seenContents;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_config["default"].setContentsAsSeen) {
                  seenFromStore = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SEEN_CONTENTS) || {};

                  if (seenFromStore) {
                    seenContents = JSON.parse((0, _stringify["default"])(seenFromStore));

                    if (seenContents && contents && contents.length > 0) {
                      contents.forEach(function (tile) {
                        if (seenContents[tile.id] && !seenContents[tile.id].seen) {
                          seenContents[tile.id].seen = (0, _now["default"])();
                        } else if (!seenContents[tile.id]) {
                          seenContents[tile.id] = {
                            seen: (0, _now["default"])()
                          };
                        }
                      });

                      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_SEEN_CONTENTS, seenContents);
                    }
                  }
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "registerForContentWithId", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(id) {
        var parsedData, parsedEntity;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!(!_this.data.contentCounter[id] || _this.data.contentCounter[id] === 0)) {
                  _context3.next = 10;
                  break;
                }

                _this.data.contentCounter[id] = 0;
                parsedData = _this.parsedData;
                parsedEntity = parsedData.find(function (el) {
                  return el.id === id;
                });

                if (!(id === _config["default"].rootId)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 10;
                break;

              case 8:
                _context3.next = 10;
                return _KESI2StoreHelper["default"].loadContentToStore(_this.data, id, _this.data.fileNames[id], _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER, parsedEntity, true);

              case 10:
                _this.data.contentCounter[id] += 1;
                return _context3.abrupt("return", _promise["default"].resolve());

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", _promise["default"].reject(_context3.t0));

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 14]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    this.data = {
      contentCounter: {},
      fileNames: {},
      courseIds: [],
      spocIds: [],
      lectureIds: [],
      nuggetIds: [],
      themes: {},
      settings: {},
      spocTree: {},
      contents: {},
      userInformed: false
    };
    this.parsedData = {};
    this.fileEntries = {};
    this.percentages = {};
    this.mandatoryLectures = [];
    this.mandatorySpocs = [];
    this.mandatoryCourses = [];
  }

  (0, _createClass2["default"])(KESI2Helper, [{
    key: "getAllContentUrl",
    value: function () {
      var _getAllContentUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_config["default"]) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return (0, _TimeoutHelper.timeout)(10);

              case 3:
                _context4.next = 0;
                break;

              case 5:
                return _context4.abrupt("return", this.getServerUrl(_config["default"].allContentRetrieveUrl));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAllContentUrl() {
        return _getAllContentUrl.apply(this, arguments);
      }

      return getAllContentUrl;
    }()
  }, {
    key: "getFilelistUrl",
    value: function () {
      var _getFilelistUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_config["default"]) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return (0, _TimeoutHelper.timeout)(10);

              case 3:
                _context5.next = 0;
                break;

              case 5:
                if (_config["default"].filelistUrl) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", null);

              case 7:
                return _context5.abrupt("return", this.getServerUrl(_config["default"].filelistUrl));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getFilelistUrl() {
        return _getFilelistUrl.apply(this, arguments);
      }

      return getFilelistUrl;
    }()
  }, {
    key: "getServerUrl",
    value: function () {
      var _getServerUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(path) {
        var longSide, isBrowser, targetTag, tagToUse, applicationInstanceId, showOnlyPublishedContent, language, useLanguageLink, languageWithoutRegionCode, version, versionStr;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                longSide = _config["default"].forceReloadFromServer ? Math.round(Math.random() * 10000) //      : Math.max(window.screen.availWidth, window.screen.availHeight)
                : Math.max(window.innerWidth, window.innerHeight);
                isBrowser = _DeviceInfoHelper["default"].isBrowser();
                targetTag = _config["default"].getTargetTag ? _config["default"].getTargetTag() : _config["default"].targetTag;
                _context6.next = 5;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.CONTENT_TAG);

              case 5:
                _context6.t0 = _context6.sent;

                if (_context6.t0) {
                  _context6.next = 8;
                  break;
                }

                _context6.t0 = targetTag;

              case 8:
                tagToUse = _context6.t0;
                _context6.next = 11;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 11:
                applicationInstanceId = _context6.sent;
                showOnlyPublishedContent = _config["default"].showOnlyPublishedContent && !(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT) === true) ? '&showOnlyPublished=true' : '';
                language = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LANGUAGE); // navigator.languages &&
                // navigator.languages[0] ||
                // navigator.language

                if (!language) {
                  language = navigator.languages ? navigator.languages[0] : navigator.language;
                } // TODO: remove target.useSnomLinkId to enable loading correct language for erv


                useLanguageLink = _config["default"].multiLanguage && _config["default"].useLanguageParam ? '&uselanglink=true' : '';
                languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/);

                if (languageWithoutRegionCode.length > 1) {
                  language = languageWithoutRegionCode[0].toUpperCase();
                } // prevent ask for unknown language


                if (_config["default"].supportedLanguages && _config["default"].supportedLanguages.length) {
                  if (_config["default"].supportedLanguages.indexOf(language.toLowerCase()) < 0) {
                    language = _config["default"].supportedLanguages[0];
                  }
                }

                version = window.BuildInfo ? window.BuildInfo.version : '';
                versionStr = version ? "&version=".concat(version) : ''; // force updating content each time until caching on server is fixed
                // longSide += Math.random()

                if (!tagToUse) {
                  _context6.next = 25;
                  break;
                }

                return _context6.abrupt("return", "".concat(_BuildConstants.ECLOUD_HOST, "/").concat(path, "?clientId=").concat(applicationInstanceId, "&tag=").concat(tagToUse, "&width=").concat(longSide, "&isbrowser=").concat(isBrowser, "&language=").concat(language).concat(useLanguageLink).concat(showOnlyPublishedContent).concat(versionStr));

              case 25:
                return _context6.abrupt("return", "".concat(_BuildConstants.ECLOUD_HOST, "/").concat(path, "?clientId=").concat(applicationInstanceId, "&width=").concat(longSide).concat(useLanguageLink).concat(showOnlyPublishedContent).concat(versionStr));

              case 26:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getServerUrl(_x4) {
        return _getServerUrl.apply(this, arguments);
      }

      return getServerUrl;
    }()
  }, {
    key: "getVisibilitiesUrl",
    value: function () {
      var _getVisibilitiesUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(channelName) {
        var applicationInstanceId;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 2:
                applicationInstanceId = _context7.sent;
                return _context7.abrupt("return", "".concat(_BuildConstants.ECLOUD_HOST, "/").concat(CORDOVA_SERVER_URLS.VISIBILITIES, "?clientId=").concat(applicationInstanceId, "&channel_name=").concat(channelName));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getVisibilitiesUrl(_x5) {
        return _getVisibilitiesUrl.apply(this, arguments);
      }

      return getVisibilitiesUrl;
    }()
  }, {
    key: "getVisibilities",
    value: function () {
      var _getVisibilities = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
        var channelName, remoteVis, response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                channelName = (0, _index.getNavigationChannelName)();
                _context8.next = 3;
                return this.getVisibilitiesUrl(channelName);

              case 3:
                remoteVis = _context8.sent;
                _context8.next = 6;
                return (0, _axios["default"])({
                  method: 'GET',
                  url: remoteVis,
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                  }
                });

              case 6:
                response = _context8.sent;

                if (!(response.status === 200 && !isKesiMaster())) {
                  _context8.next = 10;
                  break;
                }

                _context8.next = 10;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, response.data);

              case 10:
                return _context8.abrupt("return", _promise["default"].resolve());

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getVisibilities() {
        return _getVisibilities.apply(this, arguments);
      }

      return getVisibilities;
    }()
  }, {
    key: "getFinishedChatsUrl",
    value: function () {
      var _getFinishedChatsUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
        var applicationInstanceId;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _RegisterInstance["default"].getApplicationInstanceId();

              case 2:
                applicationInstanceId = _context9.sent;
                return _context9.abrupt("return", "".concat(_BuildConstants.ECLOUD_HOST, "/rest/v1/").concat(CORDOVA_SERVER_URLS.FINISHED_CHATS, "?clientId=").concat(applicationInstanceId));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getFinishedChatsUrl() {
        return _getFinishedChatsUrl.apply(this, arguments);
      }

      return getFinishedChatsUrl;
    }()
  }, {
    key: "getFinishedChats",
    value: function () {
      var _getFinishedChats = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
        var remoteVis, token, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.getFinishedChatsUrl();

              case 3:
                remoteVis = _context10.sent;
                _context10.next = 6;
                return _RegisterInstance["default"].getAccessToken('eCloud:read');

              case 6:
                token = _context10.sent;
                _context10.next = 9;
                return (0, _HttpRequest.httpGet)(remoteVis, null, null, null, 2, 'Bearer ' + token);

              case 9:
                response = _context10.sent;

                if (!(response.status === 200)) {
                  _context10.next = 13;
                  break;
                }

                _context10.next = 13;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.CHAT_FINISHED, response.data);

              case 13:
                return _context10.abrupt("return", _promise["default"].resolve());

              case 16:
                _context10.prev = 16;
                _context10.t0 = _context10["catch"](0);
                console.log('error getting finished chats', _context10.t0);
                return _context10.abrupt("return", _promise["default"].resolve());

              case 20:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 16]]);
      }));

      function getFinishedChats() {
        return _getFinishedChats.apply(this, arguments);
      }

      return getFinishedChats;
    }()
  }, {
    key: "setFinishedChats",
    value: function () {
      var _setFinishedChats = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(channelName, state) {
        var remoteUrl, data, header, token, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.getFinishedChatsUrl();

              case 2:
                remoteUrl = _context11.sent;
                data = {
                  state: state,
                  channelName: channelName
                };
                header = {
                  'Content-Type': 'application/json'
                };
                _context11.next = 7;
                return _RegisterInstance["default"].getAccessToken('eCloud:read');

              case 7:
                token = _context11.sent;
                _context11.next = 10;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(remoteUrl), data, header, null, null, 'Bearer ' + token, null, null);

              case 10:
                response = _context11.sent;

                if (!(response.status !== 200)) {
                  _context11.next = 14;
                  break;
                }

                console.log('ERROR: set visibility state', response);
                return _context11.abrupt("return", _promise["default"].reject(new Error('response has not http status 200')));

              case 14:
                return _context11.abrupt("return", _promise["default"].resolve(response));

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setFinishedChats(_x6, _x7) {
        return _setFinishedChats.apply(this, arguments);
      }

      return setFinishedChats;
    }()
  }, {
    key: "setVisibilities",
    value: function () {
      var _setVisibilities = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(state) {
        var channelName, remoteVis, data, header, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                channelName = (0, _index.getNavigationChannelName)();
                _context12.next = 3;
                return this.getVisibilitiesUrl(channelName);

              case 3:
                remoteVis = _context12.sent;
                data = {
                  state: state,
                  channelName: channelName
                };
                header = {
                  'Content-Type': 'application/json'
                };
                _context12.next = 8;
                return (0, _HttpRequest.httpPostJsonEncoded)(remoteVis, data, header, null, null, null, null, null);

              case 8:
                response = _context12.sent;

                if (!(response.status !== 200)) {
                  _context12.next = 11;
                  break;
                }

                return _context12.abrupt("return", _promise["default"].reject(new Error('Could not get visibility state')));

              case 11:
                return _context12.abrupt("return", _promise["default"].resolve(response));

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function setVisibilities(_x8) {
        return _setVisibilities.apply(this, arguments);
      }

      return setVisibilities;
    }()
  }, {
    key: "copyUpdateFolderIfThereIsOne",
    value: function () {
      var _copyUpdateFolderIfThereIsOne = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        var checkResult;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (_DeviceInfoHelper["default"].isOnline()) {
                  _context13.next = 2;
                  break;
                }

                return _context13.abrupt("return", false);

              case 2:
                _context13.prev = 2;
                _context13.next = 5;
                return _CordovaFileHelper["default"].getUpdateFolder();

              case 5:
                checkResult = _context13.sent;
                return _context13.abrupt("return", checkResult && checkResult.updateAvailable ? checkResult.updateAvailable : false);

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](2);
                console.error('error checking if update is available on server', _context13.t0);
                return _context13.abrupt("return", _promise["default"].reject(_context13.t0));

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[2, 9]]);
      }));

      function copyUpdateFolderIfThereIsOne() {
        return _copyUpdateFolderIfThereIsOne.apply(this, arguments);
      }

      return copyUpdateFolderIfThereIsOne;
    }()
  }, {
    key: "isUpdateAvailable",
    value: function () {
      var _isUpdateAvailable = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
        var checkResult;
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (_DeviceInfoHelper["default"].isOnline()) {
                  _context14.next = 2;
                  break;
                }

                return _context14.abrupt("return", false);

              case 2:
                _context14.prev = 2;
                _context14.next = 5;
                return this._updateFilesFromServer(null, true, true, 60000);

              case 5:
                checkResult = _context14.sent;
                return _context14.abrupt("return", checkResult && checkResult.updateAvailable ? checkResult.updateAvailable : false);

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14["catch"](2);
                console.error('error checking if update is available on server', _context14.t0);
                return _context14.abrupt("return", _promise["default"].reject(_context14.t0));

              case 13:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[2, 9]]);
      }));

      function isUpdateAvailable() {
        return _isUpdateAvailable.apply(this, arguments);
      }

      return isUpdateAvailable;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(setProgress) {
        var silent,
            isFirstTry,
            showAlert,
            onProgress,
            result,
            _args15 = arguments;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                silent = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : false;
                isFirstTry = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : true;
                showAlert = _args15.length > 3 && _args15[3] !== undefined ? _args15[3] : false;

                onProgress = function onProgress(progressEvent) {
                  if (!setProgress) {
                    return;
                  }

                  if (progressEvent && !progressEvent.isUnzipping && progressEvent.done) {
                    setProgress((0, _strings.getString)('UPDATE_PARSING'), 50, true);
                  } else if (progressEvent && progressEvent.isUnzipping && progressEvent.done) {
                    setProgress((0, _strings.getString)('UPDATE_PARSING'), 75, true);
                  } // there should always be progressEvent.total but let's just be very sure because we have strange error reports from users


                  if (progressEvent.total) {
                    if (progressEvent.isUnzipping) {
                      // unzipping will fill the progress bar from 50 to 75 percent
                      var loadingProgress = Math.floor(progressEvent.loaded / progressEvent.total * 25) + 50;
                      setProgress((0, _strings.getString)('UPDATE_PARSING'), loadingProgress, true);
                    } else {
                      // divide it by 2 so the maximal download progress is 50% for the download
                      var _loadingProgress = Math.floor(progressEvent.loaded / progressEvent.total * 50);

                      setProgress((0, _strings.getString)('UPDATE_DOWNLOADING'), _loadingProgress, true);
                    }
                  }
                };

                _context15.prev = 4;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context15.next = 7;
                  break;
                }

                return _context15.abrupt("return", this.loadAllFilesForBrowser());

              case 7:
                if (!_DeviceInfoHelper["default"].isOnline()) {
                  _context15.next = 18;
                  break;
                }

                _context15.next = 10;
                return this._updateFilesFromServer(onProgress, true, false, null, showAlert);

              case 10:
                result = _context15.sent;

                if (!result.someFilesUpdated) {
                  _context15.next = 16;
                  break;
                }

                if (setProgress) {
                  setProgress((0, _strings.getString)('UPDATE_PARSING'), 75, true);
                }

                _context15.next = 15;
                return this.loadDataFromFilesystem(false, result.updatedFiles ? result.updatedFiles : null);

              case 15:
                return _context15.abrupt("return", true);

              case 16:
                _context15.next = 19;
                break;

              case 18:
                if (!silent) {
                  showAlert((0, _strings.getString)('UPDATE_NOT_POSSIBLE_OFFLINE'), (0, _strings.getString)('UPDATE_NOT_POSSIBLE_OFFLINE_TITLE'), true);
                }

              case 19:
                return _context15.abrupt("return", false);

              case 22:
                _context15.prev = 22;
                _context15.t0 = _context15["catch"](4);

                if (!isFirstTry) {
                  _context15.next = 27;
                  break;
                }

                console.log('error updating content in Kesi2Helper. Retrying one more time', _context15.t0);
                return _context15.abrupt("return", this.update(setProgress, silent, false));

              case 27:
                console.error('error updating content in Kesi2Helper', _context15.t0);
                return _context15.abrupt("return", _promise["default"].reject(_context15.t0));

              case 29:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[4, 22]]);
      }));

      function update(_x9) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
    /**
     * Checks if there is a data.zip in the static folder, unpacks it as the update procedure would do.
     * This is if initial content should be delivered in the IPA or APK and not forcedly by download on first start.
     * @returns {Promise<void>}
     */

  }, {
    key: "unpackCompiledDataFile",
    value: function () {
      var _unpackCompiledDataFile = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(setProgressFn) {
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", new _promise["default"]( /*#__PURE__*/function () {
                  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(resolve, reject) {
                    var onError, onSuccess;
                    return _regenerator["default"].wrap(function _callee17$(_context17) {
                      while (1) {
                        switch (_context17.prev = _context17.next) {
                          case 0:
                            onError = function onError(error) {
                              console.warn('no static folder found - weird... skipping', error);
                              resolve(false);
                            };

                            onSuccess = /*#__PURE__*/function () {
                              var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(dirEntry) {
                                var updateFolder;
                                return _regenerator["default"].wrap(function _callee16$(_context16) {
                                  while (1) {
                                    switch (_context16.prev = _context16.next) {
                                      case 0:
                                        _context16.prev = 0;
                                        _context16.next = 3;
                                        return _CordovaFileHelper["default"].initFolderNames();

                                      case 3:
                                        _context16.next = 5;
                                        return _CordovaFileHelper["default"].getUpdateFolder();

                                      case 5:
                                        updateFolder = _context16.sent;
                                        _context16.t0 = _CordovaFileHelper["default"];
                                        _context16.t1 = dirEntry;
                                        _context16.next = 10;
                                        return _CordovaFileHelper["default"].getUpdateFolder();

                                      case 10:
                                        _context16.t2 = _context16.sent;
                                        _context16.next = 13;
                                        return _context16.t0.copyFile.call(_context16.t0, _context16.t1, 'data.zip', _context16.t2, 'data.zip', true);

                                      case 13:
                                        setProgressFn((0, _strings.getString)('UNZIPPING'));
                                        setTimeout(function () {
                                          if (navigator.splashscreen && !_config["default"].useSplashScreenToHideLoading) {
                                            navigator.splashscreen.hide();
                                          }
                                        }, 200);
                                        _context16.t3 = _ZipWrapper["default"];
                                        _context16.t4 = updateFolder.nativeURL + 'data.zip';
                                        _context16.next = 19;
                                        return _CordovaFileHelper["default"].getDataFolder();

                                      case 19:
                                        _context16.t5 = _context16.sent;

                                        _context16.t6 = function (progressEvent) {// console.log(`unzipping compiled content: ${progressEvent.loaded + 1} / ${progressEvent.total}`)
                                        };

                                        _context16.next = 23;
                                        return _context16.t3.unzip.call(_context16.t3, _context16.t4, _context16.t5, _context16.t6);

                                      case 23:
                                        resolve(true);
                                        _context16.next = 29;
                                        break;

                                      case 26:
                                        _context16.prev = 26;
                                        _context16.t7 = _context16["catch"](0);
                                        resolve(false);

                                      case 29:
                                      case "end":
                                        return _context16.stop();
                                    }
                                  }
                                }, _callee16, null, [[0, 26]]);
                              }));

                              return function onSuccess(_x13) {
                                return _ref5.apply(this, arguments);
                              };
                            }();

                            window.resolveLocalFileSystemURL(window.cordova.file.applicationDirectory + 'www/static', onSuccess, onError);

                          case 3:
                          case "end":
                            return _context17.stop();
                        }
                      }
                    }, _callee17);
                  }));

                  return function (_x11, _x12) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function unpackCompiledDataFile(_x10) {
        return _unpackCompiledDataFile.apply(this, arguments);
      }

      return unpackCompiledDataFile;
    }()
    /**
     * Tries to read all files from storage and if not present loads it from server
     */

  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(onProgress) {
        var forceDownload,
            initialCallAndPrecompiledDataAvailable,
            updateAvailableInUpdateFolder,
            didCompleteReload,
            fileList,
            inconsistentFiles,
            _args19 = arguments;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                forceDownload = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : false;
                initialCallAndPrecompiledDataAvailable = _args19.length > 2 ? _args19[2] : undefined;
                _context19.prev = 2;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context19.next = 9;
                  break;
                }

                _context19.next = 6;
                return this.loadAllFilesForBrowser();

              case 6:
                return _context19.abrupt("return", _promise["default"].resolve(true));

              case 9:
                updateAvailableInUpdateFolder = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.UPDATE_AVAILABLE);
                didCompleteReload = false;
                _context19.t0 = forceDownload;

                if (_context19.t0) {
                  _context19.next = 16;
                  break;
                }

                _context19.next = 15;
                return _CordovaFileHelper["default"].dataFolderExists();

              case 15:
                _context19.t0 = !_context19.sent;

              case 16:
                if (!_context19.t0) {
                  _context19.next = 23;
                  break;
                }

                if (navigator.splashscreen && !_config["default"].useSplashScreenToHideLoading) {
                  navigator.splashscreen.hide();
                }

                _context19.next = 20;
                return this.downloadAllFiles(onProgress);

              case 20:
                didCompleteReload = true;
                _context19.next = 50;
                break;

              case 23:
                if (!updateAvailableInUpdateFolder) {
                  _context19.next = 50;
                  break;
                }

                _context19.t1 = JSON;
                _context19.next = 27;
                return _CordovaFileHelper["default"].readTextFile(_CordovaFileHelper.LOCAL_FILENAMES.FILELIST, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

              case 27:
                _context19.t2 = _context19.sent;
                fileList = _context19.t1.parse.call(_context19.t1, _context19.t2);

                if (!_config["default"].useNewDownloadFunctionalityWithoutMD5) {
                  _context19.next = 35;
                  break;
                }

                _context19.next = 32;
                return _KesiFileConsistencyHelper["default"].checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles(fileList, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, false);

              case 32:
                inconsistentFiles = _context19.sent;
                _context19.next = 38;
                break;

              case 35:
                _context19.next = 37;
                return _KesiFileConsistencyHelper["default"].checkDataFilesConsistencies(fileList, false, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

              case 37:
                inconsistentFiles = _context19.sent;

              case 38:
                if (!(!inconsistentFiles || inconsistentFiles.length === 0)) {
                  _context19.next = 45;
                  break;
                }

                _context19.next = 41;
                return _CordovaFileHelper["default"].moveFolder(_CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER, true);

              case 41:
                _context19.next = 43;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.UPDATE_AVAILABLE, false);

              case 43:
                _context19.next = 50;
                break;

              case 45:
                _context19.next = 47;
                return _CordovaFileHelper["default"].deleteDirectory(_CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

              case 47:
                _context19.next = 49;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.UPDATE_AVAILABLE, false);

              case 49:
                updateAvailableInUpdateFolder = false;

              case 50:
                _context19.next = 52;
                return this.loadDataFromFilesystem(!initialCallAndPrecompiledDataAvailable && !didCompleteReload && !updateAvailableInUpdateFolder);

              case 52:
                return _context19.abrupt("return", _promise["default"].resolve(didCompleteReload));

              case 53:
                _context19.next = 81;
                break;

              case 55:
                _context19.prev = 55;
                _context19.t3 = _context19["catch"](2);

                if (forceDownload) {
                  _context19.next = 79;
                  break;
                }

                _context19.prev = 58;

                if (!_DeviceInfoHelper["default"].isBrowser()) {
                  _context19.next = 65;
                  break;
                }

                _context19.next = 62;
                return this.loadAllFilesForBrowser(onProgress);

              case 62:
                return _context19.abrupt("return", _promise["default"].resolve(true));

              case 65:
                if (navigator.splashscreen && !_config["default"].useSplashScreenToHideLoading) {
                  navigator.splashscreen.hide();
                }

                _context19.next = 68;
                return this.downloadAllFiles(onProgress);

              case 68:
                _context19.next = 70;
                return this.loadDataFromFilesystem(false);

              case 70:
                _context19.next = 72;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.UPDATE_AVAILABLE, false);

              case 72:
                return _context19.abrupt("return", _promise["default"].resolve(true));

              case 73:
                _context19.next = 79;
                break;

              case 75:
                _context19.prev = 75;
                _context19.t4 = _context19["catch"](58);
                console.error('error downloading or reading files from storage2:', _context19.t4);
                return _context19.abrupt("return", _promise["default"].reject(_context19.t4));

              case 79:
                console.error('error downloading or reading files from storage1:', _context19.t3);
                return _context19.abrupt("return", _promise["default"].reject(_context19.t3));

              case 81:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[2, 55], [58, 75]]);
      }));

      function init(_x14) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "loadAllFilesForBrowser",
    value: function () {
      var _loadAllFilesForBrowser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
        var _this2 = this;

        var remoteFile, axiosConfig, token, response, jszip, promises, contents, flexMenu, zipFiles, spocRootEntity, _spocRootEntity;

        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.getAllContentUrl();

              case 2:
                remoteFile = _context22.sent;
                axiosConfig = {
                  method: 'GET',
                  url: remoteFile,
                  responseType: 'arraybuffer'
                };

                if (!_config["default"].backendUseBearerAuth) {
                  _context22.next = 9;
                  break;
                }

                _context22.next = 7;
                return _RegisterInstance["default"].getAccessToken('eCloud:read');

              case 7:
                token = _context22.sent;
                axiosConfig.headers = {
                  'Authorization': 'Bearer ' + token
                };

              case 9:
                _context22.next = 11;
                return (0, _axios["default"])(axiosConfig);

              case 11:
                response = _context22.sent;
                jszip = new _jszip["default"]();
                promises = [];
                contents = []; // TODO: handle FlexMenu in Browser

                flexMenu = null;
                _context22.next = 18;
                return jszip.loadAsync(response.data);

              case 18:
                zipFiles = _context22.sent;
                zipFiles.forEach( /*#__PURE__*/function () {
                  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21(file) {
                    return _regenerator["default"].wrap(function _callee21$(_context21) {
                      while (1) {
                        switch (_context21.prev = _context21.next) {
                          case 0:
                            promises.push(new _promise["default"]( /*#__PURE__*/function () {
                              var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(resolve, reject) {
                                var fileContent, json, parsedContent, cssContent;
                                return _regenerator["default"].wrap(function _callee20$(_context20) {
                                  while (1) {
                                    switch (_context20.prev = _context20.next) {
                                      case 0:
                                        _context20.prev = 0;

                                        if (!(file.indexOf('.json') !== -1)) {
                                          _context20.next = 23;
                                          break;
                                        }

                                        _context20.next = 4;
                                        return zipFiles.file(file).async('string');

                                      case 4:
                                        fileContent = _context20.sent;
                                        json = JSON.parse(fileContent);

                                        if (!json.id) {
                                          _context20.next = 16;
                                          break;
                                        }

                                        if (json.countries) {
                                          resolve();
                                        }

                                        if (json.type === 'settingsconfig') {
                                          resolve();
                                        }

                                        _context20.next = 11;
                                        return _ContentParser["default"].parseFromData(fileContent);

                                      case 11:
                                        parsedContent = _context20.sent;

                                        if (parsedContent) {
                                          _KESI2StoreHelper["default"].addEntityToStore(parsedContent);

                                          contents.push(parsedContent);
                                        }

                                        resolve();
                                        _context20.next = 21;
                                        break;

                                      case 16:
                                        if (!json.content) {
                                          _context20.next = 21;
                                          break;
                                        }

                                        _context20.next = 19;
                                        return _this2.parseData(false, fileContent, contents);

                                      case 19:
                                        _this2.data = _context20.sent;
                                        resolve();

                                      case 21:
                                        _context20.next = 28;
                                        break;

                                      case 23:
                                        if (!(file.indexOf('.css') !== -1)) {
                                          _context20.next = 28;
                                          break;
                                        }

                                        _context20.next = 26;
                                        return zipFiles.file(file).async('string');

                                      case 26:
                                        cssContent = _context20.sent;

                                        _this2.addCss(cssContent);

                                      case 28:
                                        resolve();
                                        _context20.next = 35;
                                        break;

                                      case 31:
                                        _context20.prev = 31;
                                        _context20.t0 = _context20["catch"](0);
                                        console.log(_context20.t0);
                                        reject(_context20.t0);

                                      case 35:
                                      case "end":
                                        return _context20.stop();
                                    }
                                  }
                                }, _callee20, null, [[0, 31]]);
                              }));

                              return function (_x16, _x17) {
                                return _ref7.apply(this, arguments);
                              };
                            }()));

                          case 1:
                          case "end":
                            return _context21.stop();
                        }
                      }
                    }, _callee21);
                  }));

                  return function (_x15) {
                    return _ref6.apply(this, arguments);
                  };
                }());

                if (_config["default"].usesCourses) {
                  spocRootEntity = new _SpocRoot["default"](this.data.courseIds);

                  _KESI2StoreHelper["default"].addEntityToStore(spocRootEntity);
                } else {
                  _spocRootEntity = new _SpocRoot["default"](this.data.spocIds);

                  _KESI2StoreHelper["default"].addEntityToStore(_spocRootEntity);
                }

                _context22.next = 23;
                return _promise["default"].all(promises);

              case 23:
                _KESI2StoreHelper["default"].finishedAddingEntitiesToStore();

                return _context22.abrupt("return", _promise["default"].resolve());

              case 25:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function loadAllFilesForBrowser() {
        return _loadAllFilesForBrowser.apply(this, arguments);
      }

      return loadAllFilesForBrowser;
    }()
  }, {
    key: "downloadAllFiles",
    value: function () {
      var _downloadAllFiles = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23(onProgress) {
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.t0 = this;
                _context23.t1 = onProgress;
                _context23.next = 4;
                return this.getAllContentUrl();

              case 4:
                _context23.t2 = _context23.sent;
                _context23.t3 = _CordovaFileHelper.LOCAL_FILENAMES.ALL_CONTENT;
                _context23.next = 8;
                return _CordovaFileHelper["default"].getUpdateFolder(false);

              case 8:
                _context23.t4 = _context23.sent;
                _context23.next = 11;
                return _context23.t0.downloadFiles.call(_context23.t0, _context23.t1, _context23.t2, _context23.t3, _context23.t4);

              case 11:
                _context23.next = 13;
                return _CordovaFileHelper["default"].moveFolder(_CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER, true);

              case 13:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function downloadAllFiles(_x18) {
        return _downloadAllFiles.apply(this, arguments);
      }

      return downloadAllFiles;
    }()
  }, {
    key: "downloadContentPartFiles",
    value: function () {
      var _downloadContentPartFiles = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(onProgress, inconsistentFilesWithMd5, timestamp) {
        var stillInconsistentFiles, inconsistentFilesWithTimestamp;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.t0 = this;
                _context24.t1 = onProgress;
                _context24.next = 4;
                return this.getContentUrlForFiles(inconsistentFilesWithMd5, !_config["default"].useNewDownloadFunctionalityWithoutMD5);

              case 4:
                _context24.t2 = _context24.sent;
                _context24.t3 = _CordovaFileHelper.LOCAL_FILENAMES.CONTENT_PARTS;
                _context24.next = 8;
                return _CordovaFileHelper["default"].getUpdateFolder(false);

              case 8:
                _context24.t4 = _context24.sent;
                _context24.t5 = inconsistentFilesWithMd5;
                _context24.next = 12;
                return _context24.t0.downloadFiles.call(_context24.t0, _context24.t1, _context24.t2, _context24.t3, _context24.t4, 20, true, _context24.t5);

              case 12:
                if (!_config["default"].useNewDownloadFunctionalityWithoutMD5) {
                  _context24.next = 19;
                  break;
                }

                inconsistentFilesWithTimestamp = {
                  content: inconsistentFilesWithMd5,
                  timestamp: timestamp
                };
                _context24.next = 16;
                return _KesiFileConsistencyHelper["default"].checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles(inconsistentFilesWithTimestamp, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

              case 16:
                stillInconsistentFiles = _context24.sent;
                _context24.next = 22;
                break;

              case 19:
                _context24.next = 21;
                return _KesiFileConsistencyHelper["default"].checkFileConsistencies(inconsistentFilesWithMd5, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

              case 21:
                stillInconsistentFiles = _context24.sent;

              case 22:
                if (!(!stillInconsistentFiles || stillInconsistentFiles.length > 0)) {
                  _context24.next = 24;
                  break;
                }

                throw new Error('Downloaded content parts do not match md5 in filelist. Still inconsistent files are: ' + (0, _stringify["default"])(stillInconsistentFiles));

              case 24:
                return _context24.abrupt("return", true);

              case 25:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function downloadContentPartFiles(_x19, _x20, _x21) {
        return _downloadContentPartFiles.apply(this, arguments);
      }

      return downloadContentPartFiles;
    }()
    /**
     Javascript way of having named parameters, to use when having more than 1 default parameter
     possible calls:
     _downloadFiles(onProgress, remoteFileUrl, localFileName, unzipFolderEntry) -> just the needed params
     _downloadFiles(onProgress, remoteFileUrl, localFileName, unzipFolderEntry, {isPartly = true}) -> only pass isPartly, use default value for requestTimeout
     **/

  }, {
    key: "_downloadFiles",
    value: function () {
      var _downloadFiles2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(onProgress, remoteFileUrl, localFileName, unzipFolderEntry) {
        var _ref8,
            _ref8$requestTimeout,
            requestTimeout,
            _ref8$isPartly,
            isPartly,
            _args25 = arguments;

        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _ref8 = _args25.length > 4 && _args25[4] !== undefined ? _args25[4] : {}, _ref8$requestTimeout = _ref8.requestTimeout, requestTimeout = _ref8$requestTimeout === void 0 ? 60 : _ref8$requestTimeout, _ref8$isPartly = _ref8.isPartly, isPartly = _ref8$isPartly === void 0 ? false : _ref8$isPartly;
                return _context25.abrupt("return", this.downloadFiles(onProgress, remoteFileUrl, localFileName, unzipFolderEntry, requestTimeout, isPartly));

              case 2:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function _downloadFiles(_x22, _x23, _x24, _x25) {
        return _downloadFiles2.apply(this, arguments);
      }

      return _downloadFiles;
    }()
  }, {
    key: "downloadFiles",
    value: function () {
      var _downloadFiles3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(onProgress, remoteFileUrl, localFileName, unzipFolderEntry) {
        var requestTimeout,
            isPartly,
            files,
            fileSystem,
            fileEntry,
            headers,
            token,
            ft,
            file,
            _args26 = arguments;
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                requestTimeout = _args26.length > 4 && _args26[4] !== undefined ? _args26[4] : 60;
                isPartly = _args26.length > 5 && _args26[5] !== undefined ? _args26[5] : false;
                files = _args26.length > 6 && _args26[6] !== undefined ? _args26[6] : null;

                if (_DeviceInfoHelper["default"].isOnline(true)) {
                  _context26.next = 5;
                  break;
                }

                throw new Error('Device is offline');

              case 5:
                _context26.prev = 5;
                _context26.next = 8;
                return _FileSystemWrapper["default"].requestFileSystem();

              case 8:
                fileSystem = _context26.sent;
                _context26.next = 11;
                return _FileSystemWrapper["default"].getFileEntry(fileSystem.root, localFileName, {
                  create: true,
                  exclusive: false
                });

              case 11:
                fileEntry = _context26.sent;
                headers = {};

                if (!_config["default"].backendUseBearerAuth) {
                  _context26.next = 18;
                  break;
                }

                _context26.next = 16;
                return _RegisterInstance["default"].getAccessToken('eCloud:read');

              case 16:
                token = _context26.sent;
                headers['Authorization'] = 'Bearer ' + token;

              case 18:
                ft = new _FileTransferWrapper["default"]();

                if (!(_config["default"].useNewDownloadFunctionalityWithoutMD5 && isPartly)) {
                  _context26.next = 24;
                  break;
                }

                _context26.next = 22;
                return ft.downloadWithJS(remoteFileUrl, localFileName, null, onProgress, false, null, {
                  headers: headers
                }, 'POST', true, files);

              case 22:
                _context26.next = 26;
                break;

              case 24:
                _context26.next = 26;
                return ft.download(remoteFileUrl, fileEntry.nativeURL, onProgress, false, {
                  headers: headers
                });

              case 26:
                _context26.next = 28;
                return _FileSystemWrapper["default"].getFileEntry(fileSystem.root, localFileName, {
                  create: false
                });

              case 28:
                file = _context26.sent;

                if (onProgress) {
                  onProgress({
                    done: true,
                    isDownload: true
                  });
                }

                _context26.prev = 30;
                _context26.next = 33;
                return _ZipWrapper["default"].unzip(fileEntry.nativeURL, unzipFolderEntry.nativeURL, onProgress);

              case 33:
                _context26.next = 38;
                break;

              case 35:
                _context26.prev = 35;
                _context26.t0 = _context26["catch"](30);
                return _context26.abrupt("return", _promise["default"].reject(_context26.t0));

              case 38:
                if (onProgress) {
                  onProgress({
                    done: true,
                    isUnzipping: true
                  });
                }

                _context26.next = 41;
                return _CordovaFileHelper["default"].deleteFile(localFileName);

              case 41:
                return _context26.abrupt("return", _promise["default"].resolve());

              case 44:
                _context26.prev = 44;
                _context26.t1 = _context26["catch"](5);
                console.error('error in downloadFiles', _context26.t1);
                return _context26.abrupt("return", _promise["default"].reject(new Error(_context26.t1)));

              case 48:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[5, 44], [30, 35]]);
      }));

      function downloadFiles(_x26, _x27, _x28, _x29) {
        return _downloadFiles3.apply(this, arguments);
      }

      return downloadFiles;
    }()
  }, {
    key: "getContentUrlForFiles",
    value: function () {
      var _getContentUrlForFiles = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27(filenamesAndMd5) {
        var fileNamesInUrl,
            url,
            _args27 = arguments;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                fileNamesInUrl = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : true;

              case 1:
                if (_config["default"]) {
                  _context27.next = 6;
                  break;
                }

                _context27.next = 4;
                return (0, _TimeoutHelper.timeout)(10);

              case 4:
                _context27.next = 1;
                break;

              case 6:
                _context27.next = 8;
                return this.getServerUrl(_config["default"].allContentPartUrl);

              case 8:
                url = _context27.sent;

                if (!fileNamesInUrl) {
                  _context27.next = 13;
                  break;
                }

                return _context27.abrupt("return", "".concat(url, "&files=").concat(filenamesAndMd5.map(function (entry) {
                  return entry.fileName;
                }).join(',')));

              case 13:
                return _context27.abrupt("return", url);

              case 14:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getContentUrlForFiles(_x30) {
        return _getContentUrlForFiles.apply(this, arguments);
      }

      return getContentUrlForFiles;
    }()
    /**
     *
     * @param onProgress
     * @param onlyCompareExistingFilelist If false, calculate md5 of each referenced file
     * @param dryRun -- If true, do not download the files but only check if there are updates available
     * @param requestTimeout
     * @returns {Promise<*>} Returns true if latest data files are now available and false if the files couldn't be
     *   updated
     */

  }, {
    key: "_updateFilesFromServer",
    value: function () {
      var _updateFilesFromServer2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30(onProgress, onlyCompareExistingFilelist, dryRun) {
        var _this3 = this;

        var requestTimeout,
            showAlert,
            filelistUrl,
            axiosConfig,
            token,
            options,
            axiosInstance,
            filelist,
            inconsistentFilesWithMd5,
            downloadSuccessful,
            moveFiles,
            _args30 = arguments;
        return _regenerator["default"].wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                requestTimeout = _args30.length > 3 && _args30[3] !== undefined ? _args30[3] : null;
                showAlert = _args30.length > 4 && _args30[4] !== undefined ? _args30[4] : false;
                _context30.next = 4;
                return this.getFilelistUrl();

              case 4:
                filelistUrl = _context30.sent;

                if (filelistUrl) {
                  _context30.next = 7;
                  break;
                }

                return _context30.abrupt("return", {
                  someFilesUpdated: false,
                  success: false,
                  updateAvailable: false
                });

              case 7:
                _context30.prev = 7;
                axiosConfig = {
                  method: 'GET',
                  url: filelistUrl,
                  headers: _DeviceInfoHelper["default"].isBrowser() ? {} : {
                    'User-Agent': (0, _UserAgent.getUserAgent)()
                  },
                  responseType: 'json'
                };

                if (!_config["default"].backendUseBearerAuth) {
                  _context30.next = 14;
                  break;
                }

                _context30.next = 12;
                return _RegisterInstance["default"].getAccessToken('eCloud:read');

              case 12:
                token = _context30.sent;
                axiosConfig.headers['Authorization'] = 'Bearer ' + token;

              case 14:
                // filelist must be downloaded within 10 seconds
                options = {};

                if (requestTimeout) {
                  options.timeout = requestTimeout;
                } // eslint-disable-next-line new-cap


                axiosInstance = new _axios["default"].create(options);
                _context30.next = 19;
                return axiosInstance.request(axiosConfig);

              case 19:
                filelist = _context30.sent.data;
                _context30.next = 22;
                return _CordovaFileHelper["default"].getUpdateFolder(true);

              case 22:
                if (_DeviceInfoHelper["default"].isBrowser()) {
                  _context30.next = 33;
                  break;
                }

                if (!onlyCompareExistingFilelist) {
                  _context30.next = 29;
                  break;
                }

                _context30.next = 26;
                return _KesiFileConsistencyHelper["default"].checkDataFilesConsistenciesAgainstExistingFilelistAndCopyConsistentFilesToUpdateFolderIfThereAreInconsistentFiles(filelist, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER, !dryRun);

              case 26:
                _context30.t0 = _context30.sent;
                _context30.next = 32;
                break;

              case 29:
                _context30.next = 31;
                return _KesiFileConsistencyHelper["default"].checkDataFilesConsistencies(filelist);

              case 31:
                _context30.t0 = _context30.sent;

              case 32:
                inconsistentFilesWithMd5 = _context30.t0;

              case 33:
                if (!(inconsistentFilesWithMd5 && inconsistentFilesWithMd5.length > 0)) {
                  _context30.next = 52;
                  break;
                }

                if (!dryRun) {
                  _context30.next = 36;
                  break;
                }

                return _context30.abrupt("return", {
                  updateAvailable: true,
                  success: true,
                  someFilesUpdated: false
                });

              case 36:
                if (inconsistentFilesWithMd5) {
                  inconsistentFilesWithMd5.forEach(function (fileEntry) {
                    console.log('inconsistentFiles', fileEntry);

                    _this3.removeIdAndChildrenFromStore(fileEntry.id);
                  });
                } // noinspection UnnecessaryLocalVariableJS   --> for the sake of understandability


                _context30.next = 39;
                return this.downloadContentPartFiles(onProgress, inconsistentFilesWithMd5, filelist.timestamp);

              case 39:
                downloadSuccessful = _context30.sent;

                moveFiles = /*#__PURE__*/function () {
                  var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28(resolve, reject) {
                    var returnValue;
                    return _regenerator["default"].wrap(function _callee28$(_context28) {
                      while (1) {
                        switch (_context28.prev = _context28.next) {
                          case 0:
                            _context28.next = 2;
                            return _CordovaFileHelper["default"].moveFolder(_CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER, true);

                          case 2:
                            if (_config["default"].useNewDownloadFunctionalityWithoutMD5) {
                              _context28.next = 5;
                              break;
                            }

                            _context28.next = 5;
                            return _CordovaFileHelper["default"].writeToFile((0, _stringify["default"])(filelist), _CordovaFileHelper.LOCAL_FILENAMES.FILELIST, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

                          case 5:
                            returnValue = {
                              success: true,
                              someFilesUpdated: downloadSuccessful,
                              updateAvailable: false,
                              updatedFiles: inconsistentFilesWithMd5
                            };

                            if (!resolve) {
                              _context28.next = 10;
                              break;
                            }

                            resolve(returnValue);
                            _context28.next = 11;
                            break;

                          case 10:
                            return _context28.abrupt("return", returnValue);

                          case 11:
                          case "end":
                            return _context28.stop();
                        }
                      }
                    }, _callee28);
                  }));

                  return function moveFiles(_x34, _x35) {
                    return _ref9.apply(this, arguments);
                  };
                }();

                if (!_config["default"].updateContentWithoutAsking) {
                  _context30.next = 45;
                  break;
                }

                _context30.next = 44;
                return moveFiles();

              case 44:
                return _context30.abrupt("return", _context30.sent);

              case 45:
                if (!showAlert) {
                  _context30.next = 49;
                  break;
                }

                return _context30.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var updateNowButton = {
                    callback: function callback() {
                      moveFiles(resolve, reject);
                    },
                    label: (0, _strings.getString)('UPDATE_NOW')
                  };
                  var updateLaterButton = {
                    label: (0, _strings.getString)('UPDATE_LATER'),
                    callback: function () {
                      var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29() {
                        return _regenerator["default"].wrap(function _callee29$(_context29) {
                          while (1) {
                            switch (_context29.prev = _context29.next) {
                              case 0:
                                _context29.next = 2;
                                return _CordovaFileHelper["default"].writeToFile((0, _stringify["default"])(filelist), _CordovaFileHelper.LOCAL_FILENAMES.FILELIST, _CordovaFileHelper.LOCAL_FILENAMES.UPDATE_FOLDER);

                              case 2:
                                _context29.next = 4;
                                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.UPDATE_AVAILABLE, true);

                              case 4:
                              case "end":
                                return _context29.stop();
                            }
                          }
                        }, _callee29);
                      }));

                      function callback() {
                        return _callback.apply(this, arguments);
                      }

                      return callback;
                    }()
                  };
                  (0, _MuiAlertHelper.showAlert)((0, _strings.getString)('UPDATE_AVAILABLE'), (0, _strings.getString)('UPDATE_AVAILABLE_TITLE'), true, [updateLaterButton, updateNowButton]);
                }));

              case 49:
                _context30.next = 51;
                return moveFiles();

              case 51:
                return _context30.abrupt("return", _context30.sent);

              case 52:
                return _context30.abrupt("return", {
                  success: true,
                  someFilesUpdated: false,
                  updateAvailable: false
                });

              case 55:
                _context30.prev = 55;
                _context30.t1 = _context30["catch"](7);
                console.error('error updating content', _context30.t1);
                return _context30.abrupt("return", _promise["default"].reject(_context30.t1));

              case 59:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this, [[7, 55]]);
      }));

      function _updateFilesFromServer(_x31, _x32, _x33) {
        return _updateFilesFromServer2.apply(this, arguments);
      }

      return _updateFilesFromServer;
    }()
  }, {
    key: "loadDataFromFilesystem",
    value: function () {
      var _loadDataFromFilesystem = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31(checkMd5, updatedEntities) {
        var updatedIds, allIds, spocRootEntity;
        return _regenerator["default"].wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.parseData(checkMd5, null, null, null, updatedEntities);

              case 2:
                this.data = _context31.sent;
                updatedIds = null;

                if (updatedEntities) {
                  updatedIds = updatedEntities.map(function (item) {
                    return item.id;
                  });
                }

                allIds = updatedIds ? updatedIds : this.data.courseIds.concat(this.data.spocIds).concat(this.data.lectureIds).concat(this.data.nuggetIds);
                _context31.next = 8;
                return (0, _ChunkedPromises.callPromisesInChunks)(allIds.concat(_config["default"].rootId), this.registerForContentWithId);

              case 8:
                spocRootEntity = new _SpocRoot["default"](this.data.spocIds);

                _KESI2StoreHelper["default"].addEntityToStore(spocRootEntity);

                _KESI2StoreHelper["default"].finishedAddingEntitiesToStore();

                return _context31.abrupt("return", _promise["default"].resolve());

              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function loadDataFromFilesystem(_x36, _x37) {
        return _loadDataFromFilesystem.apply(this, arguments);
      }

      return loadDataFromFilesystem;
    }()
  }, {
    key: "parseData",
    value: function () {
      var _parseData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee34(checkMd5) {
        var _this4 = this;

        var fileList,
            content,
            flexMenu,
            updatedEntities,
            isBrowser,
            filelistText,
            filelistJson,
            flexmenuText,
            flexmenuJson,
            fileEntries,
            data,
            parsedMimeTypes,
            filesToRead,
            parsedContent,
            allCoursesForTree,
            allSpocsForTree,
            allLecturesForTree,
            _args34 = arguments;
        return _regenerator["default"].wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                fileList = _args34.length > 1 && _args34[1] !== undefined ? _args34[1] : null;
                content = _args34.length > 2 && _args34[2] !== undefined ? _args34[2] : null;
                flexMenu = _args34.length > 3 && _args34[3] !== undefined ? _args34[3] : null;
                updatedEntities = _args34.length > 4 ? _args34[4] : undefined;
                _context34.prev = 4;
                isBrowser = _DeviceInfoHelper["default"].isBrowser();

                if (!isBrowser) {
                  _context34.next = 10;
                  break;
                }

                _context34.t0 = fileList;
                _context34.next = 13;
                break;

              case 10:
                _context34.next = 12;
                return _CordovaFileHelper["default"].readTextFile(_CordovaFileHelper.LOCAL_FILENAMES.FILELIST, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

              case 12:
                _context34.t0 = _context34.sent;

              case 13:
                filelistText = _context34.t0;
                filelistJson = JSON.parse(filelistText);

                if (!_config["default"].usesFlexMenu) {
                  _context34.next = 32;
                  break;
                }

                _context34.prev = 16;

                if (!isBrowser) {
                  _context34.next = 21;
                  break;
                }

                _context34.t1 = flexMenu || null;
                _context34.next = 24;
                break;

              case 21:
                _context34.next = 23;
                return _CordovaFileHelper["default"].readTextFile(_CordovaFileHelper.LOCAL_FILENAMES.FLEXMENU, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

              case 23:
                _context34.t1 = _context34.sent;

              case 24:
                flexmenuText = _context34.t1;
                // console.log('flexmenuText', flexmenuText)
                flexmenuJson = flexmenuText ? JSON.parse(flexmenuText) : null;

                if (flexmenuJson) {
                  // no need to wait for the promise
                  _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_FLEXMENU, flexmenuJson, false);
                }

                _context34.next = 32;
                break;

              case 29:
                _context34.prev = 29;
                _context34.t2 = _context34["catch"](16);
                console.log('flexMenu not found', _context34.t2);

              case 32:
                _context34.next = 34;
                return _CordovaFileHelper["default"].getAllFileEntries(_CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

              case 34:
                fileEntries = _context34.sent;
                data = {
                  contentCounter: {},
                  fileNames: {},
                  courseIds: [],
                  spocIds: [],
                  lectureIds: [],
                  nuggetIds: [],
                  voteNuggetIds: [],
                  themes: {},
                  settings: {},
                  spocTree: {
                    id: _config["default"].rootId,
                    spocs: []
                  },
                  courseTree: {
                    id: _config["default"].rootId,
                    courses: []
                  },
                  contents: {}
                };

                if (_config["default"].usesCourses) {
                  data.contents[data.courseTree.id] = data.courseTree;
                } else {
                  data.contents[data.spocTree.id] = data.spocTree;
                }

                if (!filelistJson) {
                  _context34.next = 60;
                  break;
                }

                if (!filelistJson.content) {
                  _context34.next = 58;
                  break;
                }

                // first find out which files to parse
                parsedMimeTypes = (0, _values["default"])(MIME_TYPES);
                filesToRead = filelistJson.content.map(function (fileJson) {
                  if (parsedMimeTypes.includes(fileJson.type)) {
                    return {
                      filename: fileJson.fileName,
                      id: fileJson.id,
                      md5: fileJson.md5,
                      checkMd5: checkMd5,
                      fileEntry: _DeviceInfoHelper["default"].isBrowser() ? null : fileEntries.find(function (entry) {
                        return entry.name === fileJson.fileName;
                      })
                    };
                  }

                  return null;
                }).filter(function (fileName) {
                  return fileName !== null;
                }); // if (updatedEntities) {
                //   const updatedIds = updatedEntities.map(item => item.id)
                //   console.log('updatedids', updatedEntities, updatedIds, filesToRead)
                //   if (updatedIds) {
                //     filesToRead = filesToRead.filter(el => updatedIds.indexOf(el.id) > -1 )
                //   }
                // }
                // read and parse the files

                if (!isBrowser) {
                  _context34.next = 45;
                  break;
                }

                _context34.t3 = content;
                _context34.next = 48;
                break;

              case 45:
                _context34.next = 47;
                return (0, _ChunkedPromises.callPromisesInChunks)(filesToRead, _ContentParser["default"].parseFromFile);

              case 47:
                _context34.t3 = _context34.sent;

              case 48:
                parsedContent = _context34.t3;
                parsedContent = parsedContent.filter(function (parsed) {
                  return parsed !== null;
                }); // if (!updatedEntities) {

                this.parsedData = parsedContent; // }

                allCoursesForTree = {};
                allSpocsForTree = {};
                allLecturesForTree = {}; // get ids for each type

                parsedContent.forEach(function (entity) {
                  if (entity instanceof _Course["default"]) {
                    data.courseIds.push(entity.id);
                    allCoursesForTree[entity.id] = entity;
                  } else if (entity instanceof _Spoc["default"]) {
                    data.spocIds.push(entity.id);
                    allSpocsForTree[entity.id] = entity;
                  } else if (entity instanceof _Lecture["default"]) {
                    data.lectureIds.push(entity.id);
                    allLecturesForTree[entity.id] = entity;
                  } else if (entity instanceof _Nugget["default"]) {
                    data.nuggetIds.push(entity.id);

                    if (entity instanceof _VoteNugget["default"]) {
                      data.voteNuggetIds.push(entity.id);
                    }
                  }

                  data.contents[entity.id] = entity;
                });

                if (_config["default"].usesCourses) {
                  data.courseIds.forEach(function (courseId) {
                    var course = allCoursesForTree[courseId]; // if (course.containsLectures) {

                    course.lectures = course.lectureIds && course.lectureIds.length ? course.lectureIds.map(function (lectureId) {
                      return allLecturesForTree[lectureId];
                    }) : [];
                    /**
                     * Spocs can be set active depending on the language but list of spoc ids always contains all
                     * spocs of all languages. The only difference is that the spoc file itself is not present in the
                     * file system if the spoc is set inactive.
                     *
                     * Long story short: If the file is not present (results in null), filter it from the original list.
                     */

                    course.lectures = course.lectures.filter(Boolean);
                    course.lectureIds = course.lectures.map(function (lecture) {
                      return lecture.id;
                    }); // data.courseTree.courses.push(course)
                    // } else {

                    course.spocs = course.spocIds && course.spocIds.length ? course.spocIds.map(function (spocId) {
                      return allSpocsForTree[spocId];
                    }) : [];
                    /**
                     * Spocs can be set active depending on the language but list of spoc ids always contains all
                     * spocs of all languages. The only difference is that the spoc file itself is not present in the
                     * file system if the spoc is set inactive.
                     *
                     * Long story short: If the file is not present (results in null), filter it from the original list.
                     */

                    course.spocs = course.spocs.filter(Boolean);
                    course.spocIds = course.spocs.map(function (spoc) {
                      return spoc.id;
                    });
                    data.courseTree.courses.push(course); // }
                  });
                } // complete spocTree


                data.spocIds.forEach(function (spocId) {
                  var spoc = allSpocsForTree[spocId];
                  spoc.lectures = spoc.lectureIds.map(function (lectureId) {
                    return allLecturesForTree[lectureId];
                  });
                  /**
                   * Lectures can be set active depending on the language but list of lecture ids always contains all
                   * lectures of all languages. The only difference is that the lecture file itself is not present in the
                   * file system if the lecture is set inactive.
                   *
                   * Long story short: If the file is not present (results in null), filter it from the original list.
                   */

                  spoc.lectures = spoc.lectures.filter(Boolean);
                  spoc.lectureIds = spoc.lectures.map(function (lecture) {
                    return lecture.id;
                  }); // if (!DeviceInfoHelper.isBrowser()) {
                  //   delete spoc.lectureIds
                  // }

                  data.spocTree.spocs.push(spoc);
                }); // save filename by id

                data.fileNames = parsedContent.reduce(function (acc, cur) {
                  acc[String(cur.id)] = cur.filename;
                  return acc;
                }, {});

              case 58:
                if (filelistJson.settings && !_DeviceInfoHelper["default"].isBrowser()) {
                  filelistJson.settings.forEach( /*#__PURE__*/function () {
                    var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee32(settingJson) {
                      var settingsFileAvailable, fileContent;
                      return _regenerator["default"].wrap(function _callee32$(_context32) {
                        while (1) {
                          switch (_context32.prev = _context32.next) {
                            case 0:
                              _context32.next = 2;
                              return _CordovaFileHelper["default"].getFileEntry(settingJson.fileName, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

                            case 2:
                              settingsFileAvailable = _context32.sent;
                              _context32.next = 5;
                              return _CordovaFileHelper["default"].readTextFile(settingJson.fileName, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

                            case 5:
                              fileContent = _context32.sent;
                              data.settings[settingJson.name] = {
                                fileName: settingJson.fileName,
                                url: settingJson.url,
                                config: JSON.parse(fileContent)
                              };

                            case 7:
                            case "end":
                              return _context32.stop();
                          }
                        }
                      }, _callee32);
                    }));

                    return function (_x39) {
                      return _ref10.apply(this, arguments);
                    };
                  }());
                } // also read all the theme files (will be added to document root later


                if (filelistJson.themes && !_DeviceInfoHelper["default"].isBrowser()) {
                  filelistJson.themes.forEach( /*#__PURE__*/function () {
                    var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee33(themeJson) {
                      var theme;
                      return _regenerator["default"].wrap(function _callee33$(_context33) {
                        while (1) {
                          switch (_context33.prev = _context33.next) {
                            case 0:
                              data.themes[themeJson.name] = {
                                fileName: themeJson.fileName,
                                url: themeJson.url
                              };
                              _context33.next = 3;
                              return _CordovaFileHelper["default"].readTextFile(themeJson.fileName, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

                            case 3:
                              theme = _context33.sent;

                              _this4.addCss(theme);

                            case 5:
                            case "end":
                              return _context33.stop();
                          }
                        }
                      }, _callee33);
                    }));

                    return function (_x40) {
                      return _ref11.apply(this, arguments);
                    };
                  }());
                }

              case 60:
                if (!_config["default"].isSnooApp) {
                  _context34.next = 63;
                  break;
                }

                _context34.next = 63;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.SNOO_AVAILABLE_LECTURES, data.lectureIds.length);

              case 63:
                return _context34.abrupt("return", _promise["default"].resolve(data));

              case 66:
                _context34.prev = 66;
                _context34.t4 = _context34["catch"](4);
                console.error(_context34.t4);
                return _context34.abrupt("return", _promise["default"].reject(_context34.t4));

              case 70:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[4, 66], [16, 29]]);
      }));

      function parseData(_x38) {
        return _parseData.apply(this, arguments);
      }

      return parseData;
    }()
  }, {
    key: "addCss",
    value: function () {
      var _addCss = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee35(theme) {
        var head, style;
        return _regenerator["default"].wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                head = document.head || document.getElementsByTagName('head')[0];
                style = document.createElement('style');
                style.type = 'text/css';

                if (style.styleSheet) {
                  style.styleSheet.cssText = theme;
                } else {
                  style.appendChild(document.createTextNode(theme));
                }

                head.appendChild(style);

              case 5:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35);
      }));

      function addCss(_x41) {
        return _addCss.apply(this, arguments);
      }

      return addCss;
    }()
  }, {
    key: "getVoteNuggetIds",
    value: function getVoteNuggetIds() {
      return this.data.voteNuggetIds;
    }
  }, {
    key: "getSpocTree",
    value: function getSpocTree() {
      return this.data.spocTree;
    }
  }, {
    key: "getCourseTree",
    value: function getCourseTree() {
      return this.data.courseTree;
    }
  }, {
    key: "getContentById",
    value: function getContentById(contentId) {
      return this.data.contents[contentId];
    }
  }, {
    key: "getContentByPrecondition",
    value: function getContentByPrecondition(preconditionText) {
      return (0, _values["default"])(this.data.contents).find(function (content) {
        if (content.showPrecondition) {
          return content.showPrecondition.conditions.find(function (condition) {
            return condition.indexOf(preconditionText) !== -1;
          });
        }
      });
    }
  }, {
    key: "removeIdAndChildrenFromStore",
    value: function removeIdAndChildrenFromStore(contentId) {
      var _this5 = this;

      var content = this.data.contents[contentId];

      if (content) {
        if (content.type === _Constants.CONTENT_TYPES.COURSE) {
          var lectureIds = content.lectureIds;
          var spocIds = content.spocIds;
          lectureIds.forEach(function (lectureIds) {
            _this5.removeIdAndChildrenFromStore(lectureIds);
          });
          spocIds.forEach(function (spocId) {
            _this5.removeIdAndChildrenFromStore(spocId);
          });
        } else if (content.type === _Constants.CONTENT_TYPES.SPOC) {
          var _lectureIds2 = content.lectureIds;

          _lectureIds2.forEach(function (lectureIds) {
            _this5.removeIdAndChildrenFromStore(lectureIds);
          });
        } else if (content.type === _Constants.CONTENT_TYPES.LECTURE) {
          var nuggetIds = content.nuggetIds;
          nuggetIds.forEach(function (nuggetId) {
            _this5.removeIdAndChildrenFromStore(nuggetId);
          });
        }

        console.log('deleting id from store', contentId);
        delete this.data.contents[contentId];
        console.log('deleting id from store - contents after', JSON.parse((0, _stringify["default"])((0, _keys["default"])(this.data.contents))));
      }
    }
  }, {
    key: "getContentByUuid",
    value: function getContentByUuid(uuid) {
      return (0, _values["default"])(this.data.contents).find(function (content) {
        return content.uuid === uuid;
      });
    }
  }, {
    key: "getEventSeriesByEventDateId",
    value: function getEventSeriesByEventDateId(eventDateId) {
      var _this6 = this;

      var contentToReturn = null;
      (0, _keys["default"])(this.data.contents).find(function (contentId) {
        var content = _this6.data.contents[contentId];

        if (content instanceof _EventSeries["default"]) {
          if (content.eventDates && content.eventDates.length > 0) {
            var index = content.eventDates.indexOf(eventDateId);

            if (index > -1) {
              contentToReturn = content;
              return true;
            }
          }
        }

        return false;
      });
      return contentToReturn;
    }
  }, {
    key: "getContentByTagname",
    value: function getContentByTagname(tagNames) {
      var _this7 = this;

      var path = [];
      var found = tagNames.some(function (tagName) {
        return (0, _values["default"])(_this7.data.contents).some(function (element) {
          if (element.qdaction) {
            return element.qdaction.some(function (action) {
              if (action.qdtag && action.qdtag === tagName && action.action) {
                path.push.apply(path, (0, _toConsumableArray2["default"])(_this7.getPathToContentInTree(element.id)).concat([action.action]));
                return true;
              }
            });
          }
        });
      });
      return found ? path : false;
    }
  }, {
    key: "getContentByIdTag",
    value: function getContentByIdTag(tagName) {
      var el = null;
      var found = (0, _values["default"])(this.data.contents).some(function (element) {
        if (element.idtag && element.idtag === tagName) {
          el = element;
          return true;
        }
      });
      return found ? el : null;
    }
  }, {
    key: "getSpocCount",
    value: function getSpocCount() {
      if (this.data.spocIds) {
        return this.data.spocIds.length;
      }
    }
  }, {
    key: "getCourseCount",
    value: function getCourseCount() {
      if (this.data.courseIds) {
        return this.data.courseIds.length;
      }
    }
    /**
     * This function checks the last saved md5 value against a given one.
     * Returns true if
     * @param contentId
     * @param expectedMd5
     */

  }, {
    key: "compareMd5OfContent",
    value: function compareMd5OfContent(contentId, expectedMd5) {
      var content = this.getContentById(contentId);

      if (!content) {
        return false;
      }

      if (!content.md5) {
        // optimistic approach
        return true;
      }

      return content.md5.substring(0, expectedMd5.length) === expectedMd5.substring(0, content.md5.length);
    }
  }, {
    key: "checkIfOnlyNotMandatoryNuggets",
    value: function checkIfOnlyNotMandatoryNuggets(lectureId) {
      var _this8 = this;

      if (_config["default"].markOpenedLecturesAsCompletelyRead) {
        return false;
      }

      var nuggetsWithContent = [];
      var allMandatory = true;
      var lectureContent = this.data.contents[lectureId];

      if (lectureContent) {
        var nuggetIds = lectureContent.nuggetIds;

        if (nuggetIds && nuggetIds.length > 0) {
          nuggetIds.forEach(function (nuggetId) {
            if (_this8.data.contents[nuggetId]) {
              nuggetsWithContent.push(_this8.data.contents[nuggetId]);
            }
          });

          if (nuggetsWithContent.length > 0) {
            allMandatory = nuggetsWithContent.every(function (nugget) {
              var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(nugget.showPrecondition);
              return nugget && nugget.notMandatory && nugget.notMandatory === true || failingPrecondition;
            });
          }

          return allMandatory;
        }

        return false;
      }

      return false;
    }
  }, {
    key: "getAllMandatoryNuggets",
    value: function getAllMandatoryNuggets(lectureId) {
      var _this9 = this;

      var nuggetsWithContent = [];
      var lectureContent = this.data.contents[lectureId];

      if (lectureContent) {
        var nuggets = lectureContent.nuggetIds;
        nuggets.forEach(function (nugget) {
          if (_this9.data.contents[nugget]) {
            nuggetsWithContent.push(_this9.data.contents[nugget]);
          }
        });
        nuggetsWithContent = nuggetsWithContent.filter(function (nugget) {
          return nugget.notMandatory === false;
        });
      }

      return nuggetsWithContent;
    }
  }, {
    key: "getAllLivetickerChannelIds",
    value: function () {
      var _getAllLivetickerChannelIds = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee36() {
        var _this10 = this;

        var contentToReturn;
        return _regenerator["default"].wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                contentToReturn = [];

                if (!(this.data && this.data.contents && (0, _keys["default"])(this.data.contents).length > 0 && this.data.nuggetIds)) {
                  _context36.next = 5;
                  break;
                }

                this.data.nuggetIds.forEach(function (nuggetId) {
                  if (_this10.data.contents[nuggetId]["class"] === _LiveTickerNugget["default"].CLASS) {
                    var path = _this10.getPathToContentInTree(nuggetId);

                    path.pop();
                    contentToReturn.push({
                      channelName: "".concat(_BuildConstants.ABLY_CHANNEL_PREFIX, "liveticker:").concat(_this10.data.contents[nuggetId].channel_id),
                      path: "".concat(_config["default"].baseRoute, "/").concat(path.join('!'))
                    });
                  }
                });
                _context36.next = 8;
                break;

              case 5:
                _context36.next = 7;
                return (0, _TimeoutHelper.timeout)(200);

              case 7:
                return _context36.abrupt("return", this.getAllChatChannelIds());

              case 8:
                return _context36.abrupt("return", contentToReturn);

              case 9:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function getAllLivetickerChannelIds() {
        return _getAllLivetickerChannelIds.apply(this, arguments);
      }

      return getAllLivetickerChannelIds;
    }()
  }, {
    key: "getAllChatChannelIds",
    value: function () {
      var _getAllChatChannelIds = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee37() {
        var _this11 = this;

        var contentToReturn;
        return _regenerator["default"].wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                contentToReturn = [];

                if (!(this.data && this.data.contents && (0, _keys["default"])(this.data.contents).length > 0 && this.data.nuggetIds)) {
                  _context37.next = 5;
                  break;
                }

                this.data.nuggetIds.forEach(function (nuggetId) {
                  if (_this11.data.contents[nuggetId]["class"] === _ChatNugget["default"].CLASS) {
                    var path = _this11.getPathToContentInTree(nuggetId);

                    path.pop();
                    contentToReturn.push({
                      channelName: "".concat(_BuildConstants.ABLY_CHANNEL_PREFIX, "chat:").concat(_this11.data.contents[nuggetId].channel_id),
                      path: "".concat(_config["default"].baseRoute, "/").concat(path.join('!'))
                    });
                  }
                });
                _context37.next = 8;
                break;

              case 5:
                _context37.next = 7;
                return (0, _TimeoutHelper.timeout)(200);

              case 7:
                return _context37.abrupt("return", this.getAllChatChannelIds());

              case 8:
                return _context37.abrupt("return", contentToReturn);

              case 9:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function getAllChatChannelIds() {
        return _getAllChatChannelIds.apply(this, arguments);
      }

      return getAllChatChannelIds;
    }()
  }, {
    key: "getAllCourseData",
    value: function () {
      var _getAllCourseData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee38() {
        var _this12 = this;

        var contentToReturn;
        return _regenerator["default"].wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                contentToReturn = [];

                if (!(this.data && this.data.contents && this.data.courseIds)) {
                  _context38.next = 5;
                  break;
                }

                this.data.courseIds.forEach(function (courseId) {
                  contentToReturn.push(_this12.data.contents[courseId]);
                });
                _context38.next = 8;
                break;

              case 5:
                _context38.next = 7;
                return (0, _TimeoutHelper.timeout)(200);

              case 7:
                return _context38.abrupt("return", this.getAllCourseData());

              case 8:
                return _context38.abrupt("return", contentToReturn);

              case 9:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getAllCourseData() {
        return _getAllCourseData.apply(this, arguments);
      }

      return getAllCourseData;
    }()
  }, {
    key: "getAllSpocData",
    value: function () {
      var _getAllSpocData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee39() {
        var _this13 = this;

        var contentToReturn;
        return _regenerator["default"].wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                contentToReturn = [];

                if (!(this.data && this.data.contents && this.data.spocIds)) {
                  _context39.next = 5;
                  break;
                }

                this.data.spocIds.forEach(function (spocId) {
                  contentToReturn.push(_this13.data.contents[spocId]);
                });
                _context39.next = 8;
                break;

              case 5:
                _context39.next = 7;
                return (0, _TimeoutHelper.timeout)(200);

              case 7:
                return _context39.abrupt("return", this.getAllSpocData());

              case 8:
                return _context39.abrupt("return", contentToReturn);

              case 9:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function getAllSpocData() {
        return _getAllSpocData.apply(this, arguments);
      }

      return getAllSpocData;
    }()
  }, {
    key: "checkIfLecturesDone",
    value: function checkIfLecturesDone(lectureIdArray) {
      var _this14 = this;

      return lectureIdArray && lectureIdArray.length ? lectureIdArray.every(function (lectureId) {
        var lectureContent = _this14.getContentById(lectureId);

        if (!lectureContent.active) {
          return true;
        }

        var read = _this14.checkIfContentIsMarkedAsReadInStore(lectureContent) || _this14.checkIfOnlyNotMandatoryNuggets(lectureId);

        return read;
      }) : true;
    }
  }, {
    key: "checkIfSendingCertificate",
    value: function () {
      var _checkIfSendingCertificate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee40(state) {
        var allDone, certificatePath;
        return _regenerator["default"].wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.next = 2;
                return this.checkIfAllContentDone(state);

              case 2:
                allDone = _context40.sent;
                certificatePath = "public.".concat(_config["default"].pdfFeature ? _config["default"].pdfFeature : _config["default"].requiredFeature, ".newCertificateDate");

                if (!(!_DataStore["default"].pathExists(certificatePath) && (_config["default"].sendCertificate || _config["default"].sendCertificateOnUserRequest) && !_config["default"].isDemo)) {
                  _context40.next = 11;
                  break;
                }

                if (!allDone) {
                  _context40.next = 10;
                  break;
                }

                _context40.next = 8;
                return _DataStore["default"].setSingleData(certificatePath, (0, _now["default"])());

              case 8:
                if (!_config["default"].sendCertificateOnUserRequest) {
                  _RegisterInstance["default"].getAccessToken('eCloud:read').then(function (token) {
                    (0, _HttpRequest.httpGet)(_BuildConstants.PDF_HOST + '/' + _config["default"].certificatePdfSendUrl, {}, {}, 30000, 2, 'Bearer ' + token);
                  });
                }

                return _context40.abrupt("return", true);

              case 10:
                return _context40.abrupt("return", false);

              case 11:
                return _context40.abrupt("return", false);

              case 12:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function checkIfSendingCertificate(_x42) {
        return _checkIfSendingCertificate.apply(this, arguments);
      }

      return checkIfSendingCertificate;
    }()
  }, {
    key: "sendCertificateMail",
    value: function () {
      var _sendCertificateMail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee41(salutation, name, mail, option) {
        var certificatePath;
        return _regenerator["default"].wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                certificatePath = "public.".concat(_config["default"].pdfFeature ? _config["default"].pdfFeature : _config["default"].requiredFeature, ".newCertificateDate");

                if (!_config["default"].sendCertificate) {
                  _context41.next = 13;
                  break;
                }

                _context41.prev = 2;

                _RegisterInstance["default"].getAccessToken('eCloud:read').then(function (token) {
                  (0, _HttpRequest.httpGet)(_BuildConstants.PDF_HOST + '/' + _config["default"].certificatePdfSendUrl + "&name=".concat(name, "&anrede=").concat(salutation, "&email=").concat(mail, "&option=").concat(option), {}, {}, 30000, 2, 'Bearer ' + token);
                });

                _context41.next = 6;
                return _DataStore["default"].setSingleData(certificatePath, (0, _now["default"])());

              case 6:
                return _context41.abrupt("return", true);

              case 9:
                _context41.prev = 9;
                _context41.t0 = _context41["catch"](2);
                console.log(_context41.t0);
                return _context41.abrupt("return", false);

              case 13:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, null, [[2, 9]]);
      }));

      function sendCertificateMail(_x43, _x44, _x45, _x46) {
        return _sendCertificateMail.apply(this, arguments);
      }

      return sendCertificateMail;
    }()
  }, {
    key: "getContentByPath",
    value: function getContentByPath(pathArray) {
      return this.data.contents[(0, _ArrayHelper.getLastElement)(pathArray)];
    }
  }, {
    key: "getContentTreeByPath",
    value: function getContentTreeByPath(pathArray) {
      var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // prevent endless loops on wrong pathes with empty strings, ...
      var filteredPathArray = pathArray.filter(function (pathEntry) {
        return typeof pathEntry !== 'undefined' && pathEntry !== null && pathEntry !== '';
      }); // if there is no path, we will have no tree

      if (pathArray.length === 0 || filteredPathArray.length === 0) {
        return null;
      }

      if (pathArray.length !== filteredPathArray.length) {
        console.error('ERROR', 'KESI2Helper.getContentTreeByPath', 'there was a wrong input path', (0, _stringify["default"])(pathArray));
      }

      var entityTree = tree || (_config["default"].usesCourses ? this.getCourseTree() : this.getSpocTree());

      if (!entityTree) {
        return null;
      }

      if (filteredPathArray.length === 1 && entityTree.id === filteredPathArray[0]) {
        return entityTree;
      }

      if (filteredPathArray.length > 1) {
        if (entityTree.courses) {
          var nextSubtree = entityTree.courses.find(function (course) {
            return course.id === filteredPathArray[1];
          });
          return this.getContentTreeByPath(filteredPathArray.slice(1), nextSubtree);
        }

        if (entityTree.spocs) {
          var _nextSubtree = entityTree.spocs.find(function (spoc) {
            return spoc.id === filteredPathArray[1];
          });

          if (_nextSubtree) return this.getContentTreeByPath(filteredPathArray.slice(1), _nextSubtree);
        }

        if (entityTree.lectures) {
          var _nextSubtree2 = entityTree.lectures.find(function (lecture) {
            return lecture.id === filteredPathArray[1];
          });

          return this.getContentTreeByPath(filteredPathArray.slice(1), _nextSubtree2);
        }

        if (entityTree.nuggetIds) {
          console.error('expected to return a subtree, but requested id belongs to a nugget and nuggets have no subtrees');
          return null;
        }
      } else {
        var _entityTree = tree || this.getSpocTree();

        if (_entityTree.spocs) {
          var _nextSubtree3 = _entityTree.spocs.find(function (spoc) {
            return spoc.id === filteredPathArray[1];
          });

          return this.getContentTreeByPath(filteredPathArray.slice(1), _nextSubtree3);
        }

        if (_entityTree.lectures) {
          var _nextSubtree4 = _entityTree.lectures.find(function (lecture) {
            return lecture.id === filteredPathArray[1];
          });

          return this.getContentTreeByPath(filteredPathArray.slice(1), _nextSubtree4);
        }

        if (_entityTree.nuggetIds) {
          console.error('expected to return a subtree, but requested id belongs to a nugget and nuggets have no subtrees');
          return null;
        }
      }

      return null;
    }
    /**
     * Normally, you should have the path to an element.
     *
     * If not, you can find out *one* path (the first one in order that came from server filelist)
     */

  }, {
    key: "getPathToContentInTree",
    value: function getPathToContentInTree(id) {
      if (_config["default"].usesCourses) {
        var courseTree = this.getCourseTree();

        if (!courseTree || !id) {
          return null;
        }

        if (courseTree.id === id) {
          return [courseTree.id];
        }

        var path = [courseTree.id];
        var found = courseTree.courses.some(function (course) {
          if (course.id === id) {
            path.push(course.id);
            return true;
          }

          return course.lectures.some(function (lecture) {
            if (lecture.id === id) {
              path.push(course.id);
              path.push(lecture.id);
              return true;
            }

            if (lecture.nuggetIds.includes(id)) {
              path.push(course.id);
              path.push(lecture.id);
              path.push(id);
              return true;
            }

            return false;
          }) || course.spocs.some(function (spoc) {
            if (spoc.id === id) {
              path.push(course.id);
              path.push(spoc.id);
              return true;
            }

            return spoc.lectures.some(function (lecture) {
              if (lecture.id === id) {
                path.push(course.id);
                path.push(spoc.id);
                path.push(lecture.id);
                return true;
              }

              if (lecture.nuggetIds.includes(id)) {
                path.push(course.id);
                path.push(spoc.id);
                path.push(lecture.id);
                path.push(id);
                return true;
              }

              return false;
            });
          });
        });
        return found ? path : null;
      } else {
        var spocTree = this.getSpocTree();

        if (!spocTree || !id) {
          return null;
        }

        if (spocTree.id === id) {
          return [spocTree.id];
        }

        var _path = [spocTree.id];

        var _found = spocTree.spocs.some(function (spoc) {
          if (spoc.id === id) {
            _path.push(spoc.id);

            return true;
          }

          return spoc.lectures.some(function (lecture) {
            if (lecture.id === id) {
              _path.push(spoc.id);

              _path.push(lecture.id);

              return true;
            }

            if (lecture.nuggetIds.includes(id)) {
              _path.push(spoc.id);

              _path.push(lecture.id);

              _path.push(id);

              return true;
            }

            return false;
          });
        });

        return _found ? _path : null;
      }
    }
  }, {
    key: "isIdInSpocTree",
    value: function isIdInSpocTree(id) {
      var spocTree = this.getSpocTree();

      if (spocTree.id === id) {
        return true;
      }

      return spocTree.spocs.some(function (spoc) {
        if (spoc.id === id) {
          return true;
        }

        return spoc.lectures.some(function (lecture) {
          if (lecture.id === id) {
            return true;
          }

          if (id in lecture.nuggetIds) {
            return true;
          }

          return false;
        });
      });
    }
  }, {
    key: "getCertificatePath",
    value: function getCertificatePath() {
      var _this15 = this;

      var certificateId = this.data && this.data.contents && (0, _keys["default"])(this.data.contents).find(function (key) {
        return _this15.data.contents[key]["class"] === MAZARS_CERT_TYPE;
      });
      var certContent = this.data.contents[certificateId];

      if (certificateId) {
        var path = this.getPathToContentInTree(certificateId);

        if (path.length > 1 && certContent.type === 'nugget') {
          // Remove the last element if it was a nugget, cant link to nuggets right now
          (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1);
        }

        return path;
      }

      return null;
    }
  }, {
    key: "setReadForId",
    value: function () {
      var _setReadForId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee42(id, read) {
        var isLecture,
            increaseReadLectureCountForSnoo,
            path,
            oldId,
            storedRead,
            data,
            updateValue,
            _args42 = arguments;
        return _regenerator["default"].wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                isLecture = _args42.length > 2 && _args42[2] !== undefined ? _args42[2] : false;
                increaseReadLectureCountForSnoo = _args42.length > 3 && _args42[3] !== undefined ? _args42[3] : false;

                if (!_config["default"].setReadToStore) {
                  _context42.next = 20;
                  break;
                }

                path = "".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(id, ".read");

                if (_config["default"].translateDrupalIds) {
                  oldId = _config["default"].translateDrupalIdFn(id);
                  path = "".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(oldId, ".read");
                }

                storedRead = _DataStore["default"].getElementByPathImmediately(path);

                if (!(storedRead === read)) {
                  _context42.next = 8;
                  break;
                }

                return _context42.abrupt("return");

              case 8:
                data = {};
                data[path] = read; // data[uuidPath] = read

                if (increaseReadLectureCountForSnoo) {
                  data[_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES] = (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SNOO_COUNT_READ_LECTURES) || 0) + 1;
                }

                updateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;
                data[_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE] = updateValue + 1;
                _context42.next = 15;
                return _DataStore["default"].setData(data);

              case 15:
                if (!_config["default"].markOpenedLecturesAsCompletelyRead) {
                  this.resetCachedProgressOfParents(id);
                }

                this.checkTargetSpeficicReadFns(id, read);
                return _context42.abrupt("return", _promise["default"].resolve());

              case 20:
                _promise["default"].resolve();

              case 21:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function setReadForId(_x47, _x48) {
        return _setReadForId.apply(this, arguments);
      }

      return setReadForId;
    }()
  }, {
    key: "setFavoriteForLectureId",
    value: function () {
      var _setFavoriteForLectureId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee44(id, favorite) {
        var content, lectures;
        return _regenerator["default"].wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                content = this.getContentById(id);

                if (_config["default"].setSubTilesAsFavsWhenParentIsFav && content.type === 'spoc') {
                  lectures = content.lectureIds;
                  lectures.forEach( /*#__PURE__*/function () {
                    var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee43(lectureId) {
                      return _regenerator["default"].wrap(function _callee43$(_context43) {
                        while (1) {
                          switch (_context43.prev = _context43.next) {
                            case 0:
                              _context43.next = 2;
                              return _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(lectureId, ".favorite"), favorite);

                            case 2:
                            case "end":
                              return _context43.stop();
                          }
                        }
                      }, _callee43);
                    }));

                    return function (_x51) {
                      return _ref12.apply(this, arguments);
                    };
                  }());
                }

                _context44.next = 4;
                return _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(id, ".favorite"), favorite);

              case 4:
                return _context44.abrupt("return", _promise["default"].resolve());

              case 5:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function setFavoriteForLectureId(_x49, _x50) {
        return _setFavoriteForLectureId.apply(this, arguments);
      }

      return setFavoriteForLectureId;
    }()
  }, {
    key: "deregisterForContentWithId",
    value: function deregisterForContentWithId(id) {
      var _this16 = this;

      if (this.data.contentCounter[id]) {
        this.data.contentCounter[id] -= 1;
      }

      if (this.data.contentCounter[id] <= 0) {
        _KESI2StoreHelper["default"].unloadContentFromStore(id);

        if (id === _config["default"].rootId) {
          this.data.spocIds.forEach(function (spocId) {
            return _this16.deregisterForContentWithId(spocId);
          });
        }
      }
    }
  }, {
    key: "getLastSpocOrCourseId",
    value: function getLastSpocOrCourseId(contentPathArray) {
      for (var i = contentPathArray.length - 1; i >= 0; i--) {
        var id = contentPathArray[i];
        var content = this.getContentById(contentPathArray[i]);

        if (content instanceof _Spoc["default"] || content instanceof _Course["default"]) {
          return id;
        }
      }

      return null;
    }
  }]);
  return KESI2Helper;
}();
/**
 *
 * @type {KESI2Helper}
 */


var instance = new KESI2Helper();
var _default = instance;
exports["default"] = _default;